{
 "version": 2,
 "source": "docs/*_Fields.xlsx",
 "forms": {
  "res-apartment-sell": {
   "key": "res-apartment-sell",
   "module": "property",
   "title": "Res Apartment Sell",
   "purpose": "sell",
   "category": "residential",
   "property_types": [
    "Flat / Apartment"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Flat / Apartment"
       ],
       "strict": true,
       "notes": "Pre-selected: Flat / Apartment. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / society name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1 yr",
        "1-5 yrs",
        "5-10 yrs",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "Required when Ready to move.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "hint": ">= current month",
       "notes": "Required when Under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "transact_type",
       "label": "Transaction type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New booking",
        "Resale"
       ],
       "strict": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "State RERA format",
       "notes": "Required for under-construction / new-booking listings in RERA projects.",
       "when": {
        "any": [
         {
          "field": "availability",
          "in": [
           "Under construction"
          ]
         },
         {
          "field": "transact_type",
          "in": [
           "New booking"
          ]
         }
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-house-villa-sell": {
   "key": "res-house-villa-sell",
   "module": "property",
   "title": "Res House Villa Sell",
   "purpose": "sell",
   "category": "residential",
   "property_types": [
    "Independent House / Villa"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Independent House / Villa"
       ],
       "strict": true,
       "notes": "Pre-selected: Independent House / Villa. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / colony name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Floors in the house",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-10"
      },
      {
       "name": "open_sides",
       "label": "Number of open sides",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1 yr",
        "1-5 yrs",
        "5-10 yrs",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "Required when Ready to move.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "hint": ">= current month",
       "notes": "Required when Under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "transact_type",
       "label": "Transaction type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New booking",
        "Resale"
       ],
       "strict": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "State RERA format",
       "notes": "Required for under-construction / new-booking listings in RERA projects.",
       "when": {
        "any": [
         {
          "field": "availability",
          "in": [
           "Under construction"
          ]
         },
         {
          "field": "transact_type",
          "in": [
           "New booking"
          ]
         }
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-builder-floor-sell": {
   "key": "res-builder-floor-sell",
   "module": "property",
   "title": "Res Builder Floor Sell",
   "purpose": "sell",
   "category": "residential",
   "property_types": [
    "Builder Floor"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Builder Floor"
       ],
       "strict": true,
       "notes": "Pre-selected: Builder Floor. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / society name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      },
      {
       "name": "floor_numbers",
       "label": "Floors in the unit",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Ground",
        "1",
        "2"
       ],
       "strict": true,
       "notes": "A builder-floor unit can span floors."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1 yr",
        "1-5 yrs",
        "5-10 yrs",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "Required when Ready to move.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "hint": ">= current month",
       "notes": "Required when Under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "transact_type",
       "label": "Transaction type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New booking",
        "Resale"
       ],
       "strict": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "State RERA format",
       "notes": "Required for under-construction / new-booking listings in RERA projects.",
       "when": {
        "any": [
         {
          "field": "availability",
          "in": [
           "Under construction"
          ]
         },
         {
          "field": "transact_type",
          "in": [
           "New booking"
          ]
         }
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-plot-land-sell": {
   "key": "res-plot-land-sell",
   "module": "property",
   "title": "Res Plot Land Sell",
   "purpose": "sell",
   "category": "residential",
   "property_types": [
    "Plot / Land"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Plot / Land"
       ],
       "strict": true,
       "notes": "Pre-selected: Plot / Land. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Layout / venture name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "floors_allowed",
       "label": "Floors allowed for construction",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-50"
      },
      {
       "name": "boundary_wall",
       "label": "Boundary wall",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "open_sides",
       "label": "Number of open sides",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "construction_on_property",
       "label": "Any construction done",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "None",
        "Shed",
        "Room(s)",
        "Washroom",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner plot",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "gated_community",
       "label": "Gated colony / layout",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "approval_authority",
       "label": "Approved by",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "HMDA",
        "DTCP",
        "GHMC",
        "Panchayat",
        "CRDA",
        "Other",
        "Not approved"
       ],
       "strict": true,
       "notes": "Key trust field for AP / TS plots."
      },
      {
       "name": "layout_permit_no",
       "label": "Layout / LP number",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Possession",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Immediate",
        "By date"
       ],
       "strict": true
      },
      {
       "name": "transact_type",
       "label": "Transaction type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New booking",
        "Resale"
       ],
       "strict": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "notes": "Required for new RERA layouts.",
       "when": {
        "field": "transact_type",
        "in": [
         "New booking"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-studio-1rk-sell": {
   "key": "res-studio-1rk-sell",
   "module": "property",
   "title": "Res Studio 1RK Sell",
   "purpose": "sell",
   "category": "residential",
   "property_types": [
    "1 RK / Studio Apartment"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1 RK / Studio Apartment"
       ],
       "strict": true,
       "notes": "Pre-selected: 1 RK / Studio Apartment. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / society name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Configuration",
       "rule": "system",
       "type": "int",
       "control": "Fixed",
       "hint": "1 RK / Studio",
       "notes": "Not asked; fixed by type."
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1 yr",
        "1-5 yrs",
        "5-10 yrs",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "Required when Ready to move.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "hint": ">= current month",
       "notes": "Required when Under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "transact_type",
       "label": "Transaction type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New booking",
        "Resale"
       ],
       "strict": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "State RERA format",
       "notes": "Required for under-construction / new-booking listings in RERA projects.",
       "when": {
        "any": [
         {
          "field": "availability",
          "in": [
           "Under construction"
          ]
         },
         {
          "field": "transact_type",
          "in": [
           "New booking"
          ]
         }
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-serviced-apt-sell": {
   "key": "res-serviced-apt-sell",
   "module": "property",
   "title": "Res Serviced Apt Sell",
   "purpose": "sell",
   "category": "residential",
   "property_types": [
    "Serviced Apartment"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Serviced Apartment"
       ],
       "strict": true,
       "notes": "Pre-selected: Serviced Apartment. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / society name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1 yr",
        "1-5 yrs",
        "5-10 yrs",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "Required when Ready to move.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "hint": ">= current month",
       "notes": "Required when Under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "transact_type",
       "label": "Transaction type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New booking",
        "Resale"
       ],
       "strict": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "State RERA format",
       "notes": "Required for under-construction / new-booking listings in RERA projects.",
       "when": {
        "any": [
         {
          "field": "availability",
          "in": [
           "Under construction"
          ]
         },
         {
          "field": "transact_type",
          "in": [
           "New booking"
          ]
         }
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "services",
       "label": "Services included",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Housekeeping",
        "Laundry",
        "Meals",
        "Wi-Fi",
        "Electricity"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-farmhouse-sell": {
   "key": "res-farmhouse-sell",
   "module": "property",
   "title": "Res Farmhouse Sell",
   "purpose": "sell",
   "category": "residential",
   "property_types": [
    "Farmhouse"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Farmhouse"
       ],
       "strict": true,
       "notes": "Pre-selected: Farmhouse. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / village name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Floors in the house",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-10"
      },
      {
       "name": "farm_water",
       "label": "Water source (farm)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Borewell",
        "Canal",
        "Open well",
        "None"
       ],
       "strict": true
      },
      {
       "name": "farm_features",
       "label": "Swimming pool / lawn",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Lawn",
        "Orchard",
        "Party area"
       ],
       "strict": true,
       "notes": "Farmhouses also rent for events - link to function-hall module later."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1 yr",
        "1-5 yrs",
        "5-10 yrs",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "Required when Ready to move.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "hint": ">= current month",
       "notes": "Required when Under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "transact_type",
       "label": "Transaction type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New booking",
        "Resale"
       ],
       "strict": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "State RERA format",
       "notes": "Required for under-construction / new-booking listings in RERA projects.",
       "when": {
        "any": [
         {
          "field": "availability",
          "in": [
           "Under construction"
          ]
         },
         {
          "field": "transact_type",
          "in": [
           "New booking"
          ]
         }
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-apartment-rent": {
   "key": "res-apartment-rent",
   "module": "property",
   "title": "Res Apartment Rent",
   "purpose": "rent",
   "category": "residential",
   "property_types": [
    "Flat / Apartment"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Flat / Apartment"
       ],
       "strict": true,
       "notes": "Pre-selected: Flat / Apartment. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / society name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "has_gym",
       "label": "Gym",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "gated_security",
       "label": "Gated security",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "water_supply",
       "label": "Water supply",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Corporation",
        "Borewell",
        "Both"
       ],
       "strict": true
      },
      {
       "name": "parking_type",
       "label": "Parking (rent)",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Bike",
        "Car",
        "Both",
        "None"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "amenities_nb",
       "label": "Amenities (NoBroker list)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon checkboxes",
       "options": [
        "Lift",
        "Internet",
        "Air conditioner",
        "Club house",
        "Intercom",
        "Swimming pool",
        "Children play area",
        "Fire safety",
        "Servant room",
        "Shopping center",
        "Gas pipeline",
        "Park",
        "Rain water harvesting",
        "Sewage treatment plant",
        "House keeping",
        "Power backup",
        "Visitor parking"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "age_band",
       "label": "Property age",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Less than a year",
        "1-3 years",
        "3-5 years",
        "5-10 years",
        "More than 10 years"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "tenant-prefs",
     "title": "Tenant prefs",
     "fields": [
      {
       "name": "preferred_tenants",
       "label": "Preferred tenants",
       "rule": "required",
       "type": "enum_list",
       "control": "Checkboxes",
       "options": [
        "Anyone",
        "Family",
        "Bachelor female",
        "Bachelor male",
        "Company"
       ],
       "strict": true,
       "notes": "'Anyone' ticks all."
      },
      {
       "name": "pets_allowed",
       "label": "Pets allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "nonveg_allowed",
       "label": "Non-veg allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "visits",
     "title": "Visits",
     "fields": [
      {
       "name": "shown_by",
       "label": "Who will show the property",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Need help",
        "I will show",
        "Neighbours",
        "Friends / relatives",
        "Security",
        "Tenants",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "occupancy_status",
       "label": "Current property condition",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vacant",
        "Tenant on notice period",
        "New property",
        "Need help to manage"
       ],
       "strict": true
      },
      {
       "name": "secondary_phone",
       "label": "Secondary number",
       "rule": "optional",
       "type": "phone",
       "control": "Country code + number"
      },
      {
       "name": "more_units",
       "label": "More similar units available",
       "rule": "optional",
       "type": "bool",
       "control": "No / Yes buttons"
      },
      {
       "name": "directions_tip",
       "label": "Directions tip for tenants",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "notes": "'Don't want calls asking location?'"
      },
      {
       "name": "visit_days",
       "label": "Visit availability",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "Everyday",
        "Weekday (Mon-Fri)",
        "Weekend (Sat-Sun)"
       ],
       "strict": true
      },
      {
       "name": "visit_window",
       "label": "Visit time window",
       "rule": "optional",
       "type": "object",
       "control": "Two time pickers + 'Available all day'"
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-house-villa-rent": {
   "key": "res-house-villa-rent",
   "module": "property",
   "title": "Res House Villa Rent",
   "purpose": "rent",
   "category": "residential",
   "property_types": [
    "Independent House / Villa"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Independent House / Villa"
       ],
       "strict": true,
       "notes": "Pre-selected: Independent House / Villa. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / colony name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Floors in the house",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-10"
      },
      {
       "name": "open_sides",
       "label": "Number of open sides",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "has_gym",
       "label": "Gym",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "gated_security",
       "label": "Gated security",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "water_supply",
       "label": "Water supply",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Corporation",
        "Borewell",
        "Both"
       ],
       "strict": true
      },
      {
       "name": "parking_type",
       "label": "Parking (rent)",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Bike",
        "Car",
        "Both",
        "None"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "amenities_nb",
       "label": "Amenities (NoBroker list)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon checkboxes",
       "options": [
        "Lift",
        "Internet",
        "Air conditioner",
        "Club house",
        "Intercom",
        "Swimming pool",
        "Children play area",
        "Fire safety",
        "Servant room",
        "Shopping center",
        "Gas pipeline",
        "Park",
        "Rain water harvesting",
        "Sewage treatment plant",
        "House keeping",
        "Power backup",
        "Visitor parking"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_portion",
       "label": "Portion for rent",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Entire house",
        "Ground floor",
        "First floor",
        "Other portion"
       ],
       "strict": true,
       "notes": "Common for AP / TS houses."
      },
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "tenant-prefs",
     "title": "Tenant prefs",
     "fields": [
      {
       "name": "preferred_tenants",
       "label": "Preferred tenants",
       "rule": "required",
       "type": "enum_list",
       "control": "Checkboxes",
       "options": [
        "Anyone",
        "Family",
        "Bachelor female",
        "Bachelor male",
        "Company"
       ],
       "strict": true,
       "notes": "'Anyone' ticks all."
      },
      {
       "name": "pets_allowed",
       "label": "Pets allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "nonveg_allowed",
       "label": "Non-veg allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "visits",
     "title": "Visits",
     "fields": [
      {
       "name": "shown_by",
       "label": "Who will show the property",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Need help",
        "I will show",
        "Neighbours",
        "Friends / relatives",
        "Security",
        "Tenants",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "occupancy_status",
       "label": "Current property condition",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vacant",
        "Tenant on notice period",
        "New property",
        "Need help to manage"
       ],
       "strict": true
      },
      {
       "name": "secondary_phone",
       "label": "Secondary number",
       "rule": "optional",
       "type": "phone",
       "control": "Country code + number"
      },
      {
       "name": "more_units",
       "label": "More similar units available",
       "rule": "optional",
       "type": "bool",
       "control": "No / Yes buttons"
      },
      {
       "name": "directions_tip",
       "label": "Directions tip for tenants",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "notes": "'Don't want calls asking location?'"
      },
      {
       "name": "visit_days",
       "label": "Visit availability",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "Everyday",
        "Weekday (Mon-Fri)",
        "Weekend (Sat-Sun)"
       ],
       "strict": true
      },
      {
       "name": "visit_window",
       "label": "Visit time window",
       "rule": "optional",
       "type": "object",
       "control": "Two time pickers + 'Available all day'"
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-builder-floor-rent": {
   "key": "res-builder-floor-rent",
   "module": "property",
   "title": "Res Builder Floor Rent",
   "purpose": "rent",
   "category": "residential",
   "property_types": [
    "Builder Floor"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Builder Floor"
       ],
       "strict": true,
       "notes": "Pre-selected: Builder Floor. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / society name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      },
      {
       "name": "floor_numbers",
       "label": "Floors in the unit",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Ground",
        "1",
        "2"
       ],
       "strict": true,
       "notes": "A builder-floor unit can span floors."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "has_gym",
       "label": "Gym",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "gated_security",
       "label": "Gated security",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "water_supply",
       "label": "Water supply",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Corporation",
        "Borewell",
        "Both"
       ],
       "strict": true
      },
      {
       "name": "parking_type",
       "label": "Parking (rent)",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Bike",
        "Car",
        "Both",
        "None"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "amenities_nb",
       "label": "Amenities (NoBroker list)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon checkboxes",
       "options": [
        "Lift",
        "Internet",
        "Air conditioner",
        "Club house",
        "Intercom",
        "Swimming pool",
        "Children play area",
        "Fire safety",
        "Servant room",
        "Shopping center",
        "Gas pipeline",
        "Park",
        "Rain water harvesting",
        "Sewage treatment plant",
        "House keeping",
        "Power backup",
        "Visitor parking"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "age_band",
       "label": "Property age",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Less than a year",
        "1-3 years",
        "3-5 years",
        "5-10 years",
        "More than 10 years"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "tenant-prefs",
     "title": "Tenant prefs",
     "fields": [
      {
       "name": "preferred_tenants",
       "label": "Preferred tenants",
       "rule": "required",
       "type": "enum_list",
       "control": "Checkboxes",
       "options": [
        "Anyone",
        "Family",
        "Bachelor female",
        "Bachelor male",
        "Company"
       ],
       "strict": true,
       "notes": "'Anyone' ticks all."
      },
      {
       "name": "pets_allowed",
       "label": "Pets allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "nonveg_allowed",
       "label": "Non-veg allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "visits",
     "title": "Visits",
     "fields": [
      {
       "name": "shown_by",
       "label": "Who will show the property",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Need help",
        "I will show",
        "Neighbours",
        "Friends / relatives",
        "Security",
        "Tenants",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "occupancy_status",
       "label": "Current property condition",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vacant",
        "Tenant on notice period",
        "New property",
        "Need help to manage"
       ],
       "strict": true
      },
      {
       "name": "secondary_phone",
       "label": "Secondary number",
       "rule": "optional",
       "type": "phone",
       "control": "Country code + number"
      },
      {
       "name": "more_units",
       "label": "More similar units available",
       "rule": "optional",
       "type": "bool",
       "control": "No / Yes buttons"
      },
      {
       "name": "directions_tip",
       "label": "Directions tip for tenants",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "notes": "'Don't want calls asking location?'"
      },
      {
       "name": "visit_days",
       "label": "Visit availability",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "Everyday",
        "Weekday (Mon-Fri)",
        "Weekend (Sat-Sun)"
       ],
       "strict": true
      },
      {
       "name": "visit_window",
       "label": "Visit time window",
       "rule": "optional",
       "type": "object",
       "control": "Two time pickers + 'Available all day'"
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-studio-1rk-rent": {
   "key": "res-studio-1rk-rent",
   "module": "property",
   "title": "Res Studio 1RK Rent",
   "purpose": "rent",
   "category": "residential",
   "property_types": [
    "1 RK / Studio Apartment"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1 RK / Studio Apartment"
       ],
       "strict": true,
       "notes": "Pre-selected: 1 RK / Studio Apartment. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / society name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Configuration",
       "rule": "system",
       "type": "int",
       "control": "Fixed",
       "hint": "1 RK / Studio",
       "notes": "Not asked; fixed by type."
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "has_gym",
       "label": "Gym",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "gated_security",
       "label": "Gated security",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "water_supply",
       "label": "Water supply",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Corporation",
        "Borewell",
        "Both"
       ],
       "strict": true
      },
      {
       "name": "parking_type",
       "label": "Parking (rent)",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Bike",
        "Car",
        "Both",
        "None"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "amenities_nb",
       "label": "Amenities (NoBroker list)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon checkboxes",
       "options": [
        "Lift",
        "Internet",
        "Air conditioner",
        "Club house",
        "Intercom",
        "Swimming pool",
        "Children play area",
        "Fire safety",
        "Servant room",
        "Shopping center",
        "Gas pipeline",
        "Park",
        "Rain water harvesting",
        "Sewage treatment plant",
        "House keeping",
        "Power backup",
        "Visitor parking"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "age_band",
       "label": "Property age",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Less than a year",
        "1-3 years",
        "3-5 years",
        "5-10 years",
        "More than 10 years"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "tenant-prefs",
     "title": "Tenant prefs",
     "fields": [
      {
       "name": "preferred_tenants",
       "label": "Preferred tenants",
       "rule": "required",
       "type": "enum_list",
       "control": "Checkboxes",
       "options": [
        "Anyone",
        "Family",
        "Bachelor female",
        "Bachelor male",
        "Company"
       ],
       "strict": true,
       "notes": "'Anyone' ticks all."
      },
      {
       "name": "pets_allowed",
       "label": "Pets allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "nonveg_allowed",
       "label": "Non-veg allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "visits",
     "title": "Visits",
     "fields": [
      {
       "name": "shown_by",
       "label": "Who will show the property",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Need help",
        "I will show",
        "Neighbours",
        "Friends / relatives",
        "Security",
        "Tenants",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "occupancy_status",
       "label": "Current property condition",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vacant",
        "Tenant on notice period",
        "New property",
        "Need help to manage"
       ],
       "strict": true
      },
      {
       "name": "secondary_phone",
       "label": "Secondary number",
       "rule": "optional",
       "type": "phone",
       "control": "Country code + number"
      },
      {
       "name": "more_units",
       "label": "More similar units available",
       "rule": "optional",
       "type": "bool",
       "control": "No / Yes buttons"
      },
      {
       "name": "directions_tip",
       "label": "Directions tip for tenants",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "notes": "'Don't want calls asking location?'"
      },
      {
       "name": "visit_days",
       "label": "Visit availability",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "Everyday",
        "Weekday (Mon-Fri)",
        "Weekend (Sat-Sun)"
       ],
       "strict": true
      },
      {
       "name": "visit_window",
       "label": "Visit time window",
       "rule": "optional",
       "type": "object",
       "control": "Two time pickers + 'Available all day'"
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-serviced-apt-rent": {
   "key": "res-serviced-apt-rent",
   "module": "property",
   "title": "Res Serviced Apt Rent",
   "purpose": "rent",
   "category": "residential",
   "property_types": [
    "Serviced Apartment"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Serviced Apartment"
       ],
       "strict": true,
       "notes": "Pre-selected: Serviced Apartment. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / society name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "has_gym",
       "label": "Gym",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "gated_security",
       "label": "Gated security",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "water_supply",
       "label": "Water supply",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Corporation",
        "Borewell",
        "Both"
       ],
       "strict": true
      },
      {
       "name": "parking_type",
       "label": "Parking (rent)",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Bike",
        "Car",
        "Both",
        "None"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "amenities_nb",
       "label": "Amenities (NoBroker list)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon checkboxes",
       "options": [
        "Lift",
        "Internet",
        "Air conditioner",
        "Club house",
        "Intercom",
        "Swimming pool",
        "Children play area",
        "Fire safety",
        "Servant room",
        "Shopping center",
        "Gas pipeline",
        "Park",
        "Rain water harvesting",
        "Sewage treatment plant",
        "House keeping",
        "Power backup",
        "Visitor parking"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "age_band",
       "label": "Property age",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Less than a year",
        "1-3 years",
        "3-5 years",
        "5-10 years",
        "More than 10 years"
       ],
       "strict": true,
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per day / week / month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "services",
       "label": "Services included",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Housekeeping",
        "Laundry",
        "Meals",
        "Wi-Fi",
        "Electricity"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "tenant-prefs",
     "title": "Tenant prefs",
     "fields": [
      {
       "name": "preferred_tenants",
       "label": "Preferred tenants",
       "rule": "required",
       "type": "enum_list",
       "control": "Checkboxes",
       "options": [
        "Anyone",
        "Family",
        "Bachelor female",
        "Bachelor male",
        "Company"
       ],
       "strict": true,
       "notes": "'Anyone' ticks all."
      },
      {
       "name": "pets_allowed",
       "label": "Pets allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "nonveg_allowed",
       "label": "Non-veg allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "visits",
     "title": "Visits",
     "fields": [
      {
       "name": "shown_by",
       "label": "Who will show the property",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Need help",
        "I will show",
        "Neighbours",
        "Friends / relatives",
        "Security",
        "Tenants",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "occupancy_status",
       "label": "Current property condition",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vacant",
        "Tenant on notice period",
        "New property",
        "Need help to manage"
       ],
       "strict": true
      },
      {
       "name": "secondary_phone",
       "label": "Secondary number",
       "rule": "optional",
       "type": "phone",
       "control": "Country code + number"
      },
      {
       "name": "more_units",
       "label": "More similar units available",
       "rule": "optional",
       "type": "bool",
       "control": "No / Yes buttons"
      },
      {
       "name": "directions_tip",
       "label": "Directions tip for tenants",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "notes": "'Don't want calls asking location?'"
      },
      {
       "name": "visit_days",
       "label": "Visit availability",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "Everyday",
        "Weekday (Mon-Fri)",
        "Weekend (Sat-Sun)"
       ],
       "strict": true
      },
      {
       "name": "visit_window",
       "label": "Visit time window",
       "rule": "optional",
       "type": "object",
       "control": "Two time pickers + 'Available all day'"
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-farmhouse-rent": {
   "key": "res-farmhouse-rent",
   "module": "property",
   "title": "Res Farmhouse Rent",
   "purpose": "rent",
   "category": "residential",
   "property_types": [
    "Farmhouse"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Farmhouse"
       ],
       "strict": true,
       "notes": "Pre-selected: Farmhouse. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project / village name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true
      },
      {
       "name": "bathrooms",
       "label": "Bathrooms",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5+"
       ],
       "strict": true
      },
      {
       "name": "balconies",
       "label": "Balconies",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0",
        "1",
        "2",
        "3",
        "More than 3"
       ],
       "strict": true
      },
      {
       "name": "other_rooms",
       "label": "Other rooms",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pooja room",
        "Study room",
        "Servant room",
        "Store room"
       ],
       "strict": true
      },
      {
       "name": "total_floors",
       "label": "Floors in the house",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-10"
      },
      {
       "name": "farm_water",
       "label": "Water source (farm)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Borewell",
        "Canal",
        "Open well",
        "None"
       ],
       "strict": true
      },
      {
       "name": "farm_features",
       "label": "Swimming pool / lawn",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Lawn",
        "Orchard",
        "Party area"
       ],
       "strict": true,
       "notes": "Farmhouses also rent for events - link to function-hall module later."
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true,
       "notes": "Popular filter in AP/TS (vastu)."
      },
      {
       "name": "overlooking",
       "label": "Overlooking",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pool",
        "Park / Garden",
        "Club",
        "Main road",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner property",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      },
      {
       "name": "furnishing_items",
       "label": "Furnishing items",
       "rule": "conditional",
       "type": "object",
       "control": "Checkbox grid with counters",
       "options": [
        "Light",
        "Fan",
        "AC",
        "TV",
        "Bed",
        "Wardrobe",
        "Geyser",
        "Sofa",
        "Washing machine",
        "Stove",
        "Fridge",
        "Water purifier",
        "Microwave",
        "Modular kitchen",
        "Chimney",
        "Dining table",
        "Curtains",
        "Exhaust fan"
       ],
       "strict": false,
       "notes": "Shown only when Furnished / Semi-furnished.",
       "when": {
        "field": "furnishing",
        "in": [
         "Furnished",
         "Semi-furnished"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vitrified",
        "Marble",
        "Ceramic tiles",
        "Granite",
        "Wooden",
        "Mosaic",
        "Normal tiles / Kota",
        "Cement",
        "Stone",
        "Vinyl",
        "IPS finish",
        "Spartex",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "parking_covered",
       "label": "Covered parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "parking_open",
       "label": "Open parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "Partial",
        "Full"
       ],
       "strict": true
      },
      {
       "name": "water_source",
       "label": "Water source",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Municipal corporation",
        "Borewell / tank",
        "24x7 water"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "home_amenities",
       "label": "Home amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Power back-up",
        "Lift",
        "Air conditioned",
        "Intercom",
        "Piped gas",
        "Water purifier",
        "Modular kitchen",
        "Private garden / terrace",
        "Servant quarters",
        "Security / fire alarm"
       ],
       "strict": true
      },
      {
       "name": "society_amenities",
       "label": "Society amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      },
      {
       "name": "gated_community",
       "label": "Gated community",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per day / month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "tenant-prefs",
     "title": "Tenant prefs",
     "fields": [
      {
       "name": "preferred_tenants",
       "label": "Preferred tenants",
       "rule": "required",
       "type": "enum_list",
       "control": "Checkboxes",
       "options": [
        "Anyone",
        "Family",
        "Bachelor female",
        "Bachelor male",
        "Company"
       ],
       "strict": true,
       "notes": "'Anyone' ticks all."
      },
      {
       "name": "pets_allowed",
       "label": "Pets allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      },
      {
       "name": "nonveg_allowed",
       "label": "Non-veg allowed",
       "rule": "required",
       "type": "bool",
       "control": "No / Yes buttons",
       "notes": "Mandatory on NoBroker."
      }
     ]
    },
    {
     "key": "visits",
     "title": "Visits",
     "fields": [
      {
       "name": "shown_by",
       "label": "Who will show the property",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Need help",
        "I will show",
        "Neighbours",
        "Friends / relatives",
        "Security",
        "Tenants",
        "Others"
       ],
       "strict": true
      },
      {
       "name": "occupancy_status",
       "label": "Current property condition",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Vacant",
        "Tenant on notice period",
        "New property",
        "Need help to manage"
       ],
       "strict": true
      },
      {
       "name": "secondary_phone",
       "label": "Secondary number",
       "rule": "optional",
       "type": "phone",
       "control": "Country code + number"
      },
      {
       "name": "more_units",
       "label": "More similar units available",
       "rule": "optional",
       "type": "bool",
       "control": "No / Yes buttons"
      },
      {
       "name": "directions_tip",
       "label": "Directions tip for tenants",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "notes": "'Don't want calls asking location?'"
      },
      {
       "name": "visit_days",
       "label": "Visit availability",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "Everyday",
        "Weekday (Mon-Fri)",
        "Weekend (Sat-Sun)"
       ],
       "strict": true
      },
      {
       "name": "visit_window",
       "label": "Visit time window",
       "rule": "optional",
       "type": "object",
       "control": "Two time pickers + 'Available all day'"
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-pg": {
   "key": "res-pg",
   "module": "property",
   "title": "Res PG",
   "purpose": "pg",
   "category": "residential",
   "property_types": [
    "PG / Hostel"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: PG. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "PG / Hostel"
       ],
       "strict": true,
       "notes": "Pre-selected: PG / Hostel. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "PG / hostel name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "rooms",
     "title": "Rooms",
     "fields": [
      {
       "name": "room_types",
       "label": "Room types available",
       "rule": "required",
       "type": "enum_list",
       "control": "Checkbox tiles",
       "options": [
        "Single",
        "Double",
        "Three",
        "Four"
       ],
       "strict": true,
       "notes": "Each ticked type gets its own sub-form (rows below)."
      },
      {
       "name": "rent",
       "label": "Expected rent per person (per type)",
       "rule": "required",
       "type": "object",
       "control": "Number box per type",
       "hint": "per month",
       "group": "room_types"
      },
      {
       "name": "deposit",
       "label": "Expected deposit per person (per type)",
       "rule": "required",
       "type": "object",
       "control": "Number box per type",
       "group": "room_types"
      },
      {
       "name": "amenities",
       "label": "Room amenities (per type)",
       "rule": "optional",
       "type": "object",
       "control": "Checkboxes per type",
       "options": [
        "Cupboard",
        "TV",
        "Bedding",
        "Geyser",
        "AC",
        "Attached bathroom"
       ],
       "strict": false,
       "group": "room_types"
      },
      {
       "name": "available",
       "label": "Beds available (per type)",
       "rule": "optional",
       "type": "object",
       "control": "Number stepper per type",
       "notes": "Not on NoBroker; useful for occupancy.",
       "group": "room_types"
      }
     ]
    },
    {
     "key": "pg-details",
     "title": "PG details",
     "fields": [
      {
       "name": "pg_name",
       "label": "PG / hostel name",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 60 chars",
       "notes": "Not asked by NoBroker."
      },
      {
       "name": "pg_gender",
       "label": "Place is available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Male",
        "Female",
        "Anyone"
       ],
       "strict": true
      },
      {
       "name": "pg_guests",
       "label": "Preferred guests",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Working professional",
        "Student",
        "Both"
       ],
       "strict": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      }
     ]
    },
    {
     "key": "food",
     "title": "Food",
     "fields": [
      {
       "name": "food_included",
       "label": "Food included",
       "rule": "required",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "meals",
       "label": "Meals",
       "rule": "conditional",
       "type": "enum_list",
       "control": "Checkboxes",
       "options": [
        "Breakfast",
        "Lunch",
        "Dinner"
       ],
       "strict": true,
       "notes": "Shown when food included.",
       "when": {
        "field": "food_included",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "food_type",
       "label": "Veg / non-veg",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Veg only",
        "Veg & non-veg"
       ],
       "strict": true,
       "notes": "Not on NoBroker; useful in AP / TS."
      }
     ]
    },
    {
     "key": "rules",
     "title": "Rules",
     "fields": [
      {
       "name": "rules",
       "label": "PG / hostel rules",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon checkboxes",
       "options": [
        "No smoking",
        "No guardians stay",
        "No girls' entry",
        "No drinking",
        "No non-veg"
       ],
       "strict": true
      },
      {
       "name": "gate_close_time",
       "label": "Gate closing time",
       "rule": "optional",
       "type": "time",
       "control": "Time picker (30-min steps)"
      },
      {
       "name": "description_pg",
       "label": "PG description",
       "rule": "optional",
       "type": "text_long",
       "control": "Text area",
       "hint": "no contact details"
      }
     ]
    },
    {
     "key": "services",
     "title": "Services",
     "fields": [
      {
       "name": "svc_laundry",
       "label": "Laundry",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "svc_cleaning",
       "label": "Room cleaning",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "svc_warden",
       "label": "Warden facility",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "directions_tip",
       "label": "Directions tip",
       "rule": "optional",
       "type": "text",
       "control": "Text area"
      },
      {
       "name": "pg_amenities",
       "label": "Available amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon checkboxes",
       "options": [
        "Common TV",
        "Mess",
        "Lift",
        "Refrigerator",
        "Wi-Fi",
        "Cooking allowed",
        "Power backup"
       ],
       "strict": true
      },
      {
       "name": "parking_type",
       "label": "Parking",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Bike",
        "Car",
        "Both",
        "None"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "visits",
     "title": "Visits",
     "fields": [
      {
       "name": "visit_schedule",
       "label": "Visit availability",
       "rule": "optional",
       "type": "object",
       "control": "Chips + time pickers",
       "options": [
        "Everyday",
        "Weekday",
        "Weekend; start-end or all day"
       ],
       "strict": false,
       "notes": "Same Schedule step as rent."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-office-sell": {
   "key": "com-office-sell",
   "module": "property",
   "title": "Com Office Sell",
   "purpose": "sell",
   "category": "commercial",
   "property_types": [
    "Office"
   ],
   "subtypes": [
    "Ready to move office space",
    "Bare shell office space",
    "Co-working office space"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Office"
       ],
       "strict": true,
       "notes": "Pre-selected: Office. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Office sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Ready to move office space",
        "Bare shell office space",
        "Co-working office space"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Building / IT park name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      },
      {
       "name": "located_inside",
       "label": "Located inside",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "IT park",
        "Business park",
        "Commercial complex",
        "Standalone building",
        "Other"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      },
      {
       "name": "construction_wall_status",
       "label": "Construction status",
       "rule": "conditional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "No walls",
        "Brick walls",
        "Cemented walls",
        "Plastered walls"
       ],
       "strict": true,
       "notes": "Only for Bare shell.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Bare shell office space"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "seats",
       "label": "Min. / max. seats",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes"
      },
      {
       "name": "cabins",
       "label": "Cabins",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-100"
      },
      {
       "name": "meeting_rooms",
       "label": "Meeting rooms",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-50"
      },
      {
       "name": "has_conference_room",
       "label": "Conference room",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "has_reception",
       "label": "Reception area",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "pantry_type",
       "label": "Pantry",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Private",
        "Shared",
        "None"
       ],
       "strict": true
      },
      {
       "name": "office_facilities",
       "label": "Furnishing / central AC / UPS",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Furnished",
        "Central AC",
        "Oxygen duct",
        "UPS"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      },
      {
       "name": "staircases",
       "label": "Staircases",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "lifts",
       "label": "Lifts",
       "rule": "optional",
       "type": "object",
       "control": "Two number steppers",
       "hint": "0-20"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "is_pre_leased",
       "label": "Pre-leased / pre-rented",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No",
       "notes": "Investor filter."
      },
      {
       "name": "pre_lease_rent",
       "label": "Current rent",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "per month",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_tenure",
       "label": "Lease tenure",
       "rule": "conditional",
       "type": "int",
       "control": "Number + unit (years)",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_increment_pct",
       "label": "Annual rent increase",
       "rule": "conditional",
       "type": "decimal",
       "control": "Number box",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_leased_to",
       "label": "Leased to (business)",
       "rule": "conditional",
       "type": "text",
       "control": "Text box + 'hide' toggle",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_lease_annual_return",
       "label": "Annual return %",
       "rule": "system",
       "type": "decimal",
       "control": "Auto-calculated",
       "hint": "rent x 12 / price",
       "notes": "Owner may hide it (99acres has the flag)."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-office-rent": {
   "key": "com-office-rent",
   "module": "property",
   "title": "Com Office Rent",
   "purpose": "rent",
   "category": "commercial",
   "property_types": [
    "Office"
   ],
   "subtypes": [
    "Ready to move office space",
    "Bare shell office space",
    "Co-working office space"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Office"
       ],
       "strict": true,
       "notes": "Pre-selected: Office. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Office sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Ready to move office space",
        "Bare shell office space",
        "Co-working office space"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Building / IT park name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      },
      {
       "name": "located_inside",
       "label": "Located inside",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "IT park",
        "Business park",
        "Commercial complex",
        "Standalone building",
        "Other"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      },
      {
       "name": "construction_wall_status",
       "label": "Construction status",
       "rule": "conditional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "No walls",
        "Brick walls",
        "Cemented walls",
        "Plastered walls"
       ],
       "strict": true,
       "notes": "Only for Bare shell.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Bare shell office space"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "seats",
       "label": "Min. / max. seats",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes"
      },
      {
       "name": "cabins",
       "label": "Cabins",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-100"
      },
      {
       "name": "meeting_rooms",
       "label": "Meeting rooms",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-50"
      },
      {
       "name": "has_conference_room",
       "label": "Conference room",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "has_reception",
       "label": "Reception area",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "pantry_type",
       "label": "Pantry",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Private",
        "Shared",
        "None"
       ],
       "strict": true
      },
      {
       "name": "office_facilities",
       "label": "Furnishing / central AC / UPS",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Furnished",
        "Central AC",
        "Oxygen duct",
        "UPS"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      },
      {
       "name": "staircases",
       "label": "Staircases",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "lifts",
       "label": "Lifts",
       "rule": "optional",
       "type": "object",
       "control": "Two number steppers",
       "hint": "0-20"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_per_seat",
       "label": "Price per seat (co-working)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "per seat per month",
       "notes": "Only for Co-working.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Co-working office space"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-retail-sell": {
   "key": "com-retail-sell",
   "module": "property",
   "title": "Com Retail Sell",
   "purpose": "sell",
   "category": "commercial",
   "property_types": [
    "Retail"
   ],
   "subtypes": [
    "Commercial Shops",
    "Commercial Showrooms",
    "Restaurant / Café",
    "Food court",
    "Multiplex"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Retail"
       ],
       "strict": true,
       "notes": "Pre-selected: Retail. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Retail sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Commercial Shops",
        "Commercial Showrooms",
        "Restaurant / Café",
        "Food court",
        "Multiplex"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Mall / complex name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      },
      {
       "name": "shop_located_inside",
       "label": "Located inside",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Mall",
        "Commercial project",
        "Residential project",
        "Retail complex / building",
        "Market / high street",
        "Other"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      },
      {
       "name": "entrance_width",
       "label": "Entrance width",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "ceiling_height",
       "label": "Ceiling height",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "located_near",
       "label": "Located near",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Entrance",
        "Elevator",
        "Stairs"
       ],
       "strict": true
      },
      {
       "name": "suitable_business",
       "label": "Suitable for",
       "rule": "optional",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "ATM",
        "Bakery",
        "Boutique",
        "Clinic",
        "Clothes",
        "Café",
        "Electronics",
        "Pharmacy",
        "Restaurant",
        "Salon",
        "Other"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      },
      {
       "name": "staircases",
       "label": "Staircases",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "lifts",
       "label": "Lifts",
       "rule": "optional",
       "type": "object",
       "control": "Two number steppers",
       "hint": "0-20"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "is_pre_leased",
       "label": "Pre-leased / pre-rented",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No",
       "notes": "Investor filter."
      },
      {
       "name": "pre_lease_rent",
       "label": "Current rent",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "per month",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_tenure",
       "label": "Lease tenure",
       "rule": "conditional",
       "type": "int",
       "control": "Number + unit (years)",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_increment_pct",
       "label": "Annual rent increase",
       "rule": "conditional",
       "type": "decimal",
       "control": "Number box",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_leased_to",
       "label": "Leased to (business)",
       "rule": "conditional",
       "type": "text",
       "control": "Text box + 'hide' toggle",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_lease_annual_return",
       "label": "Annual return %",
       "rule": "system",
       "type": "decimal",
       "control": "Auto-calculated",
       "hint": "rent x 12 / price",
       "notes": "Owner may hide it (99acres has the flag)."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-retail-rent": {
   "key": "com-retail-rent",
   "module": "property",
   "title": "Com Retail Rent",
   "purpose": "rent",
   "category": "commercial",
   "property_types": [
    "Retail"
   ],
   "subtypes": [
    "Commercial Shops",
    "Commercial Showrooms",
    "Restaurant / Café",
    "Food court",
    "Multiplex"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Retail"
       ],
       "strict": true,
       "notes": "Pre-selected: Retail. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Retail sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Commercial Shops",
        "Commercial Showrooms",
        "Restaurant / Café",
        "Food court",
        "Multiplex"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Mall / complex name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      },
      {
       "name": "shop_located_inside",
       "label": "Located inside",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Mall",
        "Commercial project",
        "Residential project",
        "Retail complex / building",
        "Market / high street",
        "Other"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      },
      {
       "name": "entrance_width",
       "label": "Entrance width",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "ceiling_height",
       "label": "Ceiling height",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "located_near",
       "label": "Located near",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Entrance",
        "Elevator",
        "Stairs"
       ],
       "strict": true
      },
      {
       "name": "suitable_business",
       "label": "Suitable for",
       "rule": "optional",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "ATM",
        "Bakery",
        "Boutique",
        "Clinic",
        "Clothes",
        "Café",
        "Electronics",
        "Pharmacy",
        "Restaurant",
        "Salon",
        "Other"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      },
      {
       "name": "staircases",
       "label": "Staircases",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "lifts",
       "label": "Lifts",
       "rule": "optional",
       "type": "object",
       "control": "Two number steppers",
       "hint": "0-20"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-land-sell": {
   "key": "com-land-sell",
   "module": "property",
   "title": "Com Land Sell",
   "purpose": "sell",
   "category": "commercial",
   "property_types": [
    "Plot / Land"
   ],
   "subtypes": [
    "Commercial Land / Inst. Land",
    "Agricultural / Farm Land",
    "Industrial Lands / Plots",
    "SCO plot"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Plot / Land"
       ],
       "strict": true,
       "notes": "Pre-selected: Plot / Land. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Plot / Land sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Commercial Land / Inst. Land",
        "Agricultural / Farm Land",
        "Industrial Lands / Plots",
        "SCO plot"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Layout / village name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone / land use",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Institutional",
        "Industrial",
        "Agricultural",
        "SEZ",
        "Mixed"
       ],
       "strict": true
      },
      {
       "name": "floors_allowed",
       "label": "Floors allowed for construction",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-50"
      },
      {
       "name": "boundary_wall",
       "label": "Boundary wall",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "open_sides",
       "label": "Number of open sides",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "construction_on_property",
       "label": "Any construction done",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "None",
        "Shed",
        "Room(s)",
        "Washroom",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner plot",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "gated_community",
       "label": "Gated colony / layout",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "approval_authority",
       "label": "Approved by",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "HMDA",
        "DTCP",
        "GHMC",
        "Panchayat",
        "CRDA",
        "Other",
        "Not approved"
       ],
       "strict": true,
       "notes": "Key trust field for AP / TS plots."
      },
      {
       "name": "layout_permit_no",
       "label": "Layout / LP number",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "survey_no",
       "label": "Survey number",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "notes": "Hidden from public by default. Show only for Agricultural / Farm Land."
      },
      {
       "name": "water_source",
       "label": "Water availability",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Borewell",
        "Canal",
        "Open well",
        "River",
        "None"
       ],
       "strict": true,
       "notes": "Show only for Agricultural / Farm Land."
      },
      {
       "name": "has_power",
       "label": "Electricity connection",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "notes": "Show only for Agricultural / Farm Land."
      },
      {
       "name": "soil_type",
       "label": "Soil type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Red",
        "Black",
        "Alluvial",
        "Sandy",
        "Other"
       ],
       "strict": true,
       "notes": "Show only for Agricultural / Farm Land."
      },
      {
       "name": "conversion_status",
       "label": "Land-use conversion",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Agricultural",
        "Converted (NALA)",
        "Applied"
       ],
       "strict": true,
       "notes": "Telangana NALA conversion. Show only for Agricultural / Farm Land."
      },
      {
       "name": "has_passbook",
       "label": "Pattadar passbook available",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "notes": "Dharani / Bhu Bharati record. Show only for Agricultural / Farm Land."
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      },
      {
       "name": "transact_type",
       "label": "Transaction type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New booking",
        "Resale"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-land-rent": {
   "key": "com-land-rent",
   "module": "property",
   "title": "Com Land Rent",
   "purpose": "rent",
   "category": "commercial",
   "property_types": [
    "Plot / Land"
   ],
   "subtypes": [
    "Commercial Land / Inst. Land",
    "Agricultural / Farm Land",
    "Industrial Lands / Plots",
    "SCO plot"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Plot / Land"
       ],
       "strict": true,
       "notes": "Pre-selected: Plot / Land. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Plot / Land sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Commercial Land / Inst. Land",
        "Agricultural / Farm Land",
        "Industrial Lands / Plots",
        "SCO plot"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Layout / village name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone / land use",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Institutional",
        "Industrial",
        "Agricultural",
        "SEZ",
        "Mixed"
       ],
       "strict": true
      },
      {
       "name": "floors_allowed",
       "label": "Floors allowed for construction",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-50"
      },
      {
       "name": "boundary_wall",
       "label": "Boundary wall",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "open_sides",
       "label": "Number of open sides",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "construction_on_property",
       "label": "Any construction done",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "None",
        "Shed",
        "Room(s)",
        "Washroom",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "facing",
       "label": "Facing",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown / compass chips",
       "options": [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
       ],
       "strict": true
      },
      {
       "name": "is_corner",
       "label": "Corner plot",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "gated_community",
       "label": "Gated colony / layout",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "approval_authority",
       "label": "Approved by",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "HMDA",
        "DTCP",
        "GHMC",
        "Panchayat",
        "CRDA",
        "Other",
        "Not approved"
       ],
       "strict": true,
       "notes": "Key trust field for AP / TS plots."
      },
      {
       "name": "layout_permit_no",
       "label": "Layout / LP number",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "survey_no",
       "label": "Survey number",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "notes": "Hidden from public by default. Show only for Agricultural / Farm Land."
      },
      {
       "name": "water_source",
       "label": "Water availability",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Borewell",
        "Canal",
        "Open well",
        "River",
        "None"
       ],
       "strict": true,
       "notes": "Show only for Agricultural / Farm Land."
      },
      {
       "name": "has_power",
       "label": "Electricity connection",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "notes": "Show only for Agricultural / Farm Land."
      },
      {
       "name": "soil_type",
       "label": "Soil type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Red",
        "Black",
        "Alluvial",
        "Sandy",
        "Other"
       ],
       "strict": true,
       "notes": "Show only for Agricultural / Farm Land."
      },
      {
       "name": "conversion_status",
       "label": "Land-use conversion",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Agricultural",
        "Converted (NALA)",
        "Applied"
       ],
       "strict": true,
       "notes": "Telangana NALA conversion. Show only for Agricultural / Farm Land."
      },
      {
       "name": "has_passbook",
       "label": "Pattadar passbook available",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "notes": "Dharani / Bhu Bharati record. Show only for Agricultural / Farm Land."
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month / year)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-storage-sell": {
   "key": "com-storage-sell",
   "module": "property",
   "title": "Com Storage Sell",
   "purpose": "sell",
   "category": "commercial",
   "property_types": [
    "Storage"
   ],
   "subtypes": [
    "Ware House",
    "Cold Storage"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Storage"
       ],
       "strict": true,
       "notes": "Pre-selected: Storage. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Storage sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Ware House",
        "Cold Storage"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "ceiling_height",
       "label": "Ceiling / clear height",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "entrance_width",
       "label": "Entrance / shutter width",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "loading_docks",
       "label": "Loading docks",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper"
      },
      {
       "name": "road_width",
       "label": "Truck access road width",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "temperature_range",
       "label": "Temperature range",
       "rule": "conditional",
       "type": "object",
       "control": "Two number boxes",
       "hint": "-30 to +20",
       "notes": "Only Cold Storage.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Cold Storage"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "power_load_kva",
       "label": "Sanctioned power load",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box"
      },
      {
       "name": "floor_load_tpsm",
       "label": "Floor load capacity",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box"
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "is_pre_leased",
       "label": "Pre-leased / pre-rented",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No",
       "notes": "Investor filter."
      },
      {
       "name": "pre_lease_rent",
       "label": "Current rent",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "per month",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_tenure",
       "label": "Lease tenure",
       "rule": "conditional",
       "type": "int",
       "control": "Number + unit (years)",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_increment_pct",
       "label": "Annual rent increase",
       "rule": "conditional",
       "type": "decimal",
       "control": "Number box",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_leased_to",
       "label": "Leased to (business)",
       "rule": "conditional",
       "type": "text",
       "control": "Text box + 'hide' toggle",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_lease_annual_return",
       "label": "Annual return %",
       "rule": "system",
       "type": "decimal",
       "control": "Auto-calculated",
       "hint": "rent x 12 / price",
       "notes": "Owner may hide it (99acres has the flag)."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-storage-rent": {
   "key": "com-storage-rent",
   "module": "property",
   "title": "Com Storage Rent",
   "purpose": "rent",
   "category": "commercial",
   "property_types": [
    "Storage"
   ],
   "subtypes": [
    "Ware House",
    "Cold Storage"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Storage"
       ],
       "strict": true,
       "notes": "Pre-selected: Storage. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Storage sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Ware House",
        "Cold Storage"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "ceiling_height",
       "label": "Ceiling / clear height",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "entrance_width",
       "label": "Entrance / shutter width",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "loading_docks",
       "label": "Loading docks",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper"
      },
      {
       "name": "road_width",
       "label": "Truck access road width",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "temperature_range",
       "label": "Temperature range",
       "rule": "conditional",
       "type": "object",
       "control": "Two number boxes",
       "hint": "-30 to +20",
       "notes": "Only Cold Storage.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Cold Storage"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "power_load_kva",
       "label": "Sanctioned power load",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box"
      },
      {
       "name": "floor_load_tpsm",
       "label": "Floor load capacity",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box"
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-industry-sell": {
   "key": "com-industry-sell",
   "module": "property",
   "title": "Com Industry Sell",
   "purpose": "sell",
   "category": "commercial",
   "property_types": [
    "Industry"
   ],
   "subtypes": [
    "Factory",
    "Manufacturing"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Industry"
       ],
       "strict": true,
       "notes": "Pre-selected: Industry. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Industry sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Factory",
        "Manufacturing"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Industrial estate / park",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "ceiling_height",
       "label": "Shed height",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "power_load_kva",
       "label": "Sanctioned power load",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box"
      },
      {
       "name": "approvals",
       "label": "Industry approvals",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "TSIIC / APIIC allotment",
        "Pollution board consent",
        "Factory licence",
        "Fire NOC"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "is_pre_leased",
       "label": "Pre-leased / pre-rented",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No",
       "notes": "Investor filter."
      },
      {
       "name": "pre_lease_rent",
       "label": "Current rent",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "per month",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_tenure",
       "label": "Lease tenure",
       "rule": "conditional",
       "type": "int",
       "control": "Number + unit (years)",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_increment_pct",
       "label": "Annual rent increase",
       "rule": "conditional",
       "type": "decimal",
       "control": "Number box",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_leased_to",
       "label": "Leased to (business)",
       "rule": "conditional",
       "type": "text",
       "control": "Text box + 'hide' toggle",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_lease_annual_return",
       "label": "Annual return %",
       "rule": "system",
       "type": "decimal",
       "control": "Auto-calculated",
       "hint": "rent x 12 / price",
       "notes": "Owner may hide it (99acres has the flag)."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-industry-rent": {
   "key": "com-industry-rent",
   "module": "property",
   "title": "Com Industry Rent",
   "purpose": "rent",
   "category": "commercial",
   "property_types": [
    "Industry"
   ],
   "subtypes": [
    "Factory",
    "Manufacturing"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Industry"
       ],
       "strict": true,
       "notes": "Pre-selected: Industry. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Industry sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Factory",
        "Manufacturing"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Industrial estate / park",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "ceiling_height",
       "label": "Shed height",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "power_load_kva",
       "label": "Sanctioned power load",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box"
      },
      {
       "name": "approvals",
       "label": "Industry approvals",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "TSIIC / APIIC allotment",
        "Pollution board consent",
        "Factory licence",
        "Fire NOC"
       ],
       "strict": true
      },
      {
       "name": "road_width",
       "label": "Width of facing road",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-hospitality-sell": {
   "key": "com-hospitality-sell",
   "module": "property",
   "title": "Com Hospitality Sell",
   "purpose": "sell",
   "category": "commercial",
   "property_types": [
    "Hospitality"
   ],
   "subtypes": [
    "Hotel / Resorts",
    "Guest-House / Banquet-Halls"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Hospitality"
       ],
       "strict": true,
       "notes": "Pre-selected: Hospitality. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Hospitality sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Hotel / Resorts",
        "Guest-House / Banquet-Halls"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Hotel / venue name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "rooms_total",
       "label": "Total rooms",
       "rule": "conditional",
       "type": "int",
       "control": "Number stepper",
       "notes": "Hotels / guest houses.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Hotel / Resorts",
         "Guest-House / Banquet-Halls"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "total_floors",
       "label": "Total floors",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper"
      },
      {
       "name": "hall_capacity",
       "label": "Hall capacity (seating / floating)",
       "rule": "conditional",
       "type": "object",
       "control": "Two number boxes",
       "notes": "Banquet halls. Re-use for the function-hall module.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Guest-House / Banquet-Halls"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "kitchen_type",
       "label": "Kitchen",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Commercial kitchen",
        "Basic",
        "None"
       ],
       "strict": true
      },
      {
       "name": "ac_type",
       "label": "Air conditioning",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Central AC",
        "Split AC",
        "None"
       ],
       "strict": true
      },
      {
       "name": "licences",
       "label": "Licences in place",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Trade licence",
        "FSSAI",
        "Fire NOC",
        "Bar licence",
        "Tourism registration"
       ],
       "strict": true
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      },
      {
       "name": "staircases",
       "label": "Staircases",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "lifts",
       "label": "Lifts",
       "rule": "optional",
       "type": "object",
       "control": "Two number steppers",
       "hint": "0-20"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "is_pre_leased",
       "label": "Pre-leased / pre-rented",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No",
       "notes": "Investor filter."
      },
      {
       "name": "pre_lease_rent",
       "label": "Current rent",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "per month",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_tenure",
       "label": "Lease tenure",
       "rule": "conditional",
       "type": "int",
       "control": "Number + unit (years)",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_increment_pct",
       "label": "Annual rent increase",
       "rule": "conditional",
       "type": "decimal",
       "control": "Number box",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_leased_to",
       "label": "Leased to (business)",
       "rule": "conditional",
       "type": "text",
       "control": "Text box + 'hide' toggle",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_lease_annual_return",
       "label": "Annual return %",
       "rule": "system",
       "type": "decimal",
       "control": "Auto-calculated",
       "hint": "rent x 12 / price",
       "notes": "Owner may hide it (99acres has the flag)."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-hospitality-rent": {
   "key": "com-hospitality-rent",
   "module": "property",
   "title": "Com Hospitality Rent",
   "purpose": "rent",
   "category": "commercial",
   "property_types": [
    "Hospitality"
   ],
   "subtypes": [
    "Hotel / Resorts",
    "Guest-House / Banquet-Halls"
   ],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Hospitality"
       ],
       "strict": true,
       "notes": "Pre-selected: Hospitality. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "Hospitality sub-type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Hotel / Resorts",
        "Guest-House / Banquet-Halls"
       ],
       "strict": true,
       "notes": "Second question appears after the type is picked."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Hotel / venue name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "plot_area",
       "label": "Plot area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Store also normalised sqft for search."
      },
      {
       "name": "plot_dimensions",
       "label": "Length x breadth",
       "rule": "optional",
       "type": "object",
       "control": "Two number boxes (ft/m)",
       "hint": "> 0",
       "notes": "Auto-check against plot area."
      },
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "rooms_total",
       "label": "Total rooms",
       "rule": "conditional",
       "type": "int",
       "control": "Number stepper",
       "notes": "Hotels / guest houses.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Hotel / Resorts",
         "Guest-House / Banquet-Halls"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "total_floors",
       "label": "Total floors",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper"
      },
      {
       "name": "hall_capacity",
       "label": "Hall capacity (seating / floating)",
       "rule": "conditional",
       "type": "object",
       "control": "Two number boxes",
       "notes": "Banquet halls. Re-use for the function-hall module.",
       "when": {
        "field": "property_subtype",
        "in": [
         "Guest-House / Banquet-Halls"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "kitchen_type",
       "label": "Kitchen",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Commercial kitchen",
        "Basic",
        "None"
       ],
       "strict": true
      },
      {
       "name": "ac_type",
       "label": "Air conditioning",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Central AC",
        "Split AC",
        "None"
       ],
       "strict": true
      },
      {
       "name": "licences",
       "label": "Licences in place",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Trade licence",
        "FSSAI",
        "Fire NOC",
        "Bar licence",
        "Tourism registration"
       ],
       "strict": true
      },
      {
       "name": "furnishing",
       "label": "Furnishing",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Furnished",
        "Semi-furnished",
        "Unfurnished"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      },
      {
       "name": "staircases",
       "label": "Staircases",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "lifts",
       "label": "Lifts",
       "rule": "optional",
       "type": "object",
       "control": "Two number steppers",
       "hint": "0-20"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "hall-venue": {
   "key": "hall-venue",
   "module": "hall",
   "title": "Function hall / venue",
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "venue_name",
       "label": "Venue name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars",
       "notes": "Shown as the listing title."
      },
      {
       "name": "primary_type",
       "label": "Primary venue type",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Function hall",
        "Banquet hall",
        "Convention centre",
        "Kalyana mandapam",
        "Lawn / garden",
        "Resort",
        "Farmhouse",
        "Hotel (3/4/5 star)",
        "Fort / palace",
        "Small party hall",
        "Rooftop / terrace",
        "Community hall"
       ],
       "strict": true,
       "notes": "Drives the category page the venue appears on."
      },
      {
       "name": "secondary_types",
       "label": "Also suitable as",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "notes": "WedMeGood shows e.g. 'Banquet Halls, Marriage Garden / Lawns' on one card.",
       "options": [
        "Function hall",
        "Banquet hall",
        "Convention centre",
        "Kalyana mandapam",
        "Lawn / garden",
        "Resort",
        "Farmhouse",
        "Hotel (3/4/5 star)",
        "Fort / palace",
        "Small party hall",
        "Rooftop / terrace",
        "Community hall"
       ],
       "strict": true
      },
      {
       "name": "star_category",
       "label": "Star category",
       "rule": "conditional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "3 Star",
        "4 Star",
        "5 Star",
        "5 Star Luxury"
       ],
       "strict": true,
       "notes": "Only for hotel-type venues.",
       "when": {
        "field": "primary_type",
        "in": [
         "Hotel (3/4/5 star)"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "highlight_text",
       "label": "Tagline / highlight",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 40 chars",
       "notes": "e.g. 'Pillarless Convention Hall', 'Pure Veg Venue'. Shown on the card. WMG: 'one line bio for your venue'."
      },
      {
       "name": "highlight_description",
       "label": "Highlight description",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 80 chars"
      },
      {
       "name": "food_type",
       "label": "Food served at venue",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Veg only",
        "Veg & non-veg"
       ],
       "strict": true,
       "notes": "Key filter ('Vegetarian only')."
      },
      {
       "name": "start_year",
       "label": "Year started",
       "rule": "optional",
       "type": "year",
       "control": "Year picker",
       "hint": "1900 - current year"
      },
      {
       "name": "description",
       "label": "About the venue",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "100-5000 chars",
       "notes": "AI draft from the entered fields (both portals use template-like text)."
      },
      {
       "name": "usp",
       "label": "USP",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 230 chars",
       "notes": "WMG limit 230."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "contact_mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Country code + number",
       "hint": "+91, 10 digits",
       "notes": "OTP verified. WMG: Mobile / Landline type + 'Add more' numbers."
      },
      {
       "name": "whatsapp_number",
       "label": "WhatsApp number",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile' + number"
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "manager_hours",
       "label": "Manager available hours",
       "rule": "optional",
       "type": "object",
       "control": "Two time pickers",
       "notes": "WedMeGood stores availability start/end time."
      },
      {
       "name": "links",
       "label": "Website / social links",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "options": [
        "Website",
        "Facebook",
        "Instagram",
        "YouTube / Vimeo"
       ],
       "strict": false
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master"
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (by city)",
       "hint": "Locality master",
       "notes": "Main search filter."
      },
      {
       "name": "address",
       "label": "Full address",
       "rule": "required",
       "type": "text",
       "control": "Text area",
       "notes": "Shown publicly (unlike property ads)."
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "required",
       "type": "pincode",
       "control": "Number box"
      },
      {
       "name": "landmark",
       "label": "Landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "notes": "e.g. 'Near Hanuman Temple'."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "required",
       "type": "geo",
       "control": "Map picker",
       "notes": "'View on Map' link."
      },
      {
       "name": "nearest_bus_stop",
       "label": "Nearest bus stop",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "nearest_rail",
       "label": "Nearest railway / metro station + km",
       "rule": "optional",
       "type": "object",
       "control": "Text box + number"
      },
      {
       "name": "airport_km",
       "label": "Distance from airport (km)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box"
      },
      {
       "name": "business_id",
       "label": "Other branches",
       "rule": "optional",
       "type": "location",
       "control": "Link to business profile",
       "notes": "Vaaraahi has 2 branches: model a Business with many Venues."
      }
     ]
    },
    {
     "key": "capacity",
     "title": "Capacity",
     "fields": [
      {
       "name": "guests_min",
       "label": "Guests - minimum",
       "rule": "required",
       "type": "int",
       "control": "Number box",
       "hint": ">= 1",
       "notes": "Card shows '300-1000 pax'."
      },
      {
       "name": "guests_max",
       "label": "Guests - maximum",
       "rule": "system",
       "type": "int",
       "control": "Auto from spaces",
       "hint": "max floating capacity",
       "notes": "Computed from the Spaces tab; owner can override."
      },
      {
       "name": "spaces_count",
       "label": "Total halls / spaces",
       "rule": "system",
       "type": "int",
       "control": "Auto from spaces"
      },
      {
       "name": "space_kinds",
       "label": "Space types available",
       "rule": "system",
       "type": "enum_list",
       "control": "Auto from spaces",
       "options": [
        "Indoor",
        "Outdoor",
        "Terrace / Rooftop",
        "Poolside"
       ],
       "strict": true
      },
      {
       "name": "small_party_ok",
       "label": "Small parties (< 50 pax) allowed",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "rooms-parking",
     "title": "Rooms & parking",
     "fields": [
      {
       "name": "room_count",
       "label": "Guest rooms",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-500"
      },
      {
       "name": "room_price",
       "label": "Room price (per night)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "If rooms > 0. WMG asks 'starting price for a basic room'.",
       "when": {
        "field": "room_count",
        "gt": 0
       },
       "required_when_shown": true
      },
      {
       "name": "room_min_policy",
       "label": "Minimum room booking to host a wedding",
       "rule": "conditional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Set number of rooms must be booked",
        "No room booking needed",
        "Complete buyout mandatory"
       ],
       "strict": true,
       "notes": "If rooms > 0.",
       "when": {
        "field": "room_count",
        "gt": 0
       },
       "required_when_shown": true
      },
      {
       "name": "dest_rooms_included",
       "label": "Rooms included in destination price (per night)",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "hint": "default 100",
       "notes": "For resorts / destination venues."
      },
      {
       "name": "changing_rooms",
       "label": "Bride / groom changing rooms",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper"
      },
      {
       "name": "parking_type",
       "label": "Parking",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Sufficient parking available",
        "Parking available near the venue",
        "No parking available"
       ],
       "strict": true,
       "notes": "WedMeGood: 'Parking is available near the venue'."
      },
      {
       "name": "car_parking",
       "label": "Car parking capacity",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper"
      },
      {
       "name": "bike_parking",
       "label": "Two-wheeler parking",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper"
      },
      {
       "name": "valet",
       "label": "Valet parking",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "facilities",
     "title": "Facilities",
     "fields": [
      {
       "name": "facilities",
       "label": "Facilities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips + 'free / paid' toggle each",
       "options": [
        "Central AC",
        "Stage",
        "Power backup / generator",
        "Sound system",
        "Lighting",
        "Projector",
        "Microphone",
        "LED wall",
        "Lift",
        "Separate dining area",
        "Bridal room",
        "Washrooms",
        "Wheelchair access",
        "Wi-Fi",
        "Kitchen for outside caterers",
        "CCTV",
        "Security"
       ],
       "strict": true,
       "notes": "VenueBookingz marks some as 'provided with additional charges'."
      },
      {
       "name": "venue_features",
       "label": "Venue features checklist",
       "rule": "optional",
       "type": "enum_list",
       "control": "Checkbox list",
       "options": [
        "Wheelchair friendly",
        "Sufficient parking",
        "Veg only",
        "Beachfront / beach view",
        "Complete room buyout",
        "Events < 50 people",
        "Mountain view",
        "Lake / river view",
        "Pet friendly",
        "Outside decorator allowed",
        "Outside caterer allowed",
        "Outside alcohol allowed",
        "Sea view",
        "Glasshouse"
       ],
       "strict": true,
       "notes": "Exact 14 WMG checkboxes; several repeat policy answers - derive those instead of asking twice."
      },
      {
       "name": "ac_type",
       "label": "Air conditioning",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Central AC",
        "Split AC",
        "Non-AC",
        "Partial"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "policies",
     "title": "Policies",
     "fields": [
      {
       "name": "catering_policy",
       "label": "Catering policy",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "In-house only, outside not permitted",
        "In-house, outside allowed",
        "No in-house, outside from panel only",
        "No in-house, outside allowed"
       ],
       "strict": true,
       "notes": "Exact WMG answers: 'Outside caterering only', 'Inhouse & outside catering allowed'. Exact 4 WMG dashboard options."
      },
      {
       "name": "decor_policy",
       "label": "Decor policy",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "In-house decor",
        "Outside decorators permitted",
        "Only from enlisted panel"
       ],
       "strict": true
      },
      {
       "name": "alcohol_policy",
       "label": "Alcohol policy",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "In-house available, outside permitted",
        "In-house available, outside not permitted",
        "In-house not available, outside permitted",
        "In-house not available, outside not permitted"
       ],
       "strict": true,
       "notes": "WMG uses one combined question."
      },
      {
       "name": "dj_policy",
       "label": "DJ policy",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "In-house DJ, outside permitted",
        "In-house DJ, outside not permitted",
        "No in-house DJ, outside permitted",
        "No in-house DJ, outside not permitted"
       ],
       "strict": true,
       "notes": "WMG uses one combined question."
      },
      {
       "name": "corkage_charge",
       "label": "Corkage charge",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "If outside alcohol permitted.",
       "when": {
        "field": "alcohol_policy",
        "in": [
         "In-house available, outside permitted",
         "In-house not available, outside permitted"
        ]
       },
       "required_when_shown": false
      },
      {
       "name": "music_cutoff",
       "label": "Music cut-off time",
       "rule": "optional",
       "type": "time",
       "control": "Time picker",
       "hint": "e.g. 22:00",
       "notes": "Police rule in Hyderabad; avoids disputes."
      },
      {
       "name": "homa_policy",
       "label": "Homa / fire pooja",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Allowed",
        "Designated areas only",
        "Not allowed"
       ],
       "strict": true
      },
      {
       "name": "banana_leaf_ok",
       "label": "Plantain (banana) leaf service",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "kids_free_below_age",
       "label": "Kids eat free below age",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "hint": "0-12",
       "notes": "VenueBookingz: free below 6 yrs."
      },
      {
       "name": "fireworks_baraat",
       "label": "Fireworks / baraat allowed",
       "rule": "optional",
       "type": "object",
       "control": "Two toggles"
      },
      {
       "name": "outside_vendors_ok",
       "label": "Outside vendors (photo, makeup) allowed",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      }
     ]
    },
    {
     "key": "timing-slots",
     "title": "Timing & slots",
     "fields": [
      {
       "name": "slots",
       "label": "Sessions offered",
       "rule": "required",
       "type": "object",
       "control": "Chips + start/end time per chip",
       "options": [
        "Morning / Lunch",
        "Evening / Dinner",
        "Full day",
        "Early-morning muhurtham"
       ],
       "strict": false,
       "notes": "VBZ: 9:00-15:30 and 17:00-23:00. Muhurtham slot is our addition for Telugu weddings."
      },
      {
       "name": "extra_hour_charge",
       "label": "Extra-hour charge",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "hint": "per hour"
      }
     ]
    },
    {
     "key": "pricing",
     "title": "Pricing",
     "fields": [
      {
       "name": "pricing_model",
       "label": "Pricing model",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Per plate",
        "Rental per function",
        "Both",
        "Price on request"
       ],
       "strict": true,
       "notes": "WMG cards show either per-plate or rental, or 'Price on Request'. WMG asks 'Does your venue have rental cost along with per plate cost? Yes / No'."
      },
      {
       "name": "veg_plate_price",
       "label": "Veg price per plate",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "If per plate / both. WMG: 'assume 250 pax and standard menu'.",
       "when": {
        "field": "pricing_model",
        "in": [
         "Per plate",
         "Both"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "nonveg_plate_price",
       "label": "Non-veg price per plate",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "If non-veg served. WMG: 'assume 250 pax and standard menu'.",
       "when": {
        "field": "food_type",
        "in": [
         "Veg & non-veg"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rental_per_function",
       "label": "Rental cost per function",
       "rule": "conditional",
       "type": "money",
       "control": "Number box with Lakh helper",
       "notes": "If rental / both.",
       "when": {
        "field": "pricing_model",
        "in": [
         "Rental per function",
         "Both"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "tax_mode",
       "label": "Taxes",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Taxes extra",
        "Inclusive of taxes"
       ],
       "strict": true,
       "notes": "Both portals show 'taxes extra'."
      },
      {
       "name": "decor_start_price",
       "label": "Decor starting price",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "min_plates",
       "label": "Minimum guaranteed plates",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "price_rules",
       "label": "Seasonal / weekday pricing",
       "rule": "optional",
       "type": "object",
       "control": "Table: date range or weekday -> price",
       "notes": "WMG notes prices vary by season and date; let owners set peak muhurtham days."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book how many weeks in advance",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "hint": "0-52"
      },
      {
       "name": "advance_pct",
       "label": "Advance to confirm booking",
       "rule": "required",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "VBZ: 'confirmed against 50% payment'. WMG: 'booking amount (%) to block a date'."
      },
      {
       "name": "cancellation_policy",
       "label": "Cancellation policy",
       "rule": "required",
       "type": "object",
       "control": "Dropdown + text area",
       "options": [
        "Full refund till N days",
        "Partial",
        "Non-refundable",
        "As per venue terms"
       ],
       "strict": false,
       "notes": "WMG asks: customer cancels (Partial / No refund / No refund, date can move / Full), venue cancels (Partial / No / Full), plus T&C text."
      },
      {
       "name": "security_deposit",
       "label": "Refundable security deposit",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "payment_modes",
       "label": "Payment modes",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "UPI",
        "Card",
        "Bank transfer",
        "Cash",
        "Cheque"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events_allowed",
       "label": "Events hosted",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Wedding Reception",
        "Sangeet / Mehandi",
        "Haldi",
        "Baby Shower",
        "Naming Ceremony",
        "Cradle Ceremony",
        "Half Saree Function",
        "Dhoti Function",
        "Upanayanam",
        "Ear Boring Ceremony",
        "Birthday Party",
        "Wedding Anniversary",
        "Get-Together",
        "Kitty Party",
        "Baptism",
        "Ayush Homa",
        "Bachelor Party",
        "Cocktail Party",
        "Farewell",
        "Freshers Party",
        "New Born Baby Function",
        "Lohri",
        "Beegar Oota",
        "Corporate Party",
        "Conference",
        "Seminar",
        "Workshop",
        "Training",
        "Board Meeting",
        "Product Launch",
        "Annual Function",
        "Exhibition",
        "Fashion Show",
        "Team Outing",
        "Project Party"
       ],
       "strict": true,
       "notes": "VBZ lists ~38 events incl. Telugu ones (Half Saree, Upanayanam, Cradle)."
      },
      {
       "name": "function_types",
       "label": "Function types",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pre-wedding",
        "Wedding",
        "Reception",
        "Corporate",
        "Social"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "hint": "JPG/PNG, >= 1200 px wide",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload, tag by space",
       "hint": "min 5, max 100",
       "notes": "WMG ties photos to each space (album).",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums (past events)",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, description, photos",
       "notes": "WMG 'Projects' / 'Portfolio'."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      },
      {
       "name": "tour_url",
       "label": "360° / virtual tour",
       "rule": "optional",
       "type": "url",
       "control": "Text box"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "aspect_ratings",
       "label": "Ratings by aspect",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "1-5",
       "notes": "From reviews; VBZ shows 4 aspects."
      },
      {
       "name": "rating_summary",
       "label": "Overall rating & review count",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "enquiry_count",
       "label": "Enquiries received",
       "rule": "system",
       "type": "int",
       "control": "-",
       "notes": "'9369 people checked availability'."
      },
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since 7 years'."
      },
      {
       "name": "badge",
       "label": "Verified / plan badge",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": false,
       "notes": "Paid tiers on both portals."
      },
      {
       "name": "availability_checked_at",
       "label": "Availability last checked",
       "rule": "system",
       "type": "datetime",
       "control": "-"
      }
     ]
    }
   ],
   "groups": {
    "spaces": {
     "title": "Halls / spaces",
     "min": 1,
     "max": 20,
     "fields": [
      {
       "name": "name",
       "label": "Space name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "notes": "e.g. 'Hall 1', 'Jaipur Pink Fort & Lawns'.",
       "group": "spaces"
      },
      {
       "name": "kind",
       "label": "Space type",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Banquet hall",
        "Lawn",
        "Convention hall",
        "Mandapam",
        "Terrace / Rooftop",
        "Poolside",
        "Amphitheatre",
        "Dining hall"
       ],
       "strict": true,
       "group": "spaces"
      },
      {
       "name": "indoor_outdoor",
       "label": "Space type (WMG)",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Indoor",
        "Outdoor",
        "Indoor & Outdoor",
        "Poolside",
        "Terrace"
       ],
       "strict": true,
       "notes": "WMG codes 1 / 2 / 3.",
       "group": "spaces"
      },
      {
       "name": "seating",
       "label": "Seating capacity",
       "rule": "required",
       "type": "int",
       "control": "Number box",
       "hint": "> 0",
       "group": "spaces"
      },
      {
       "name": "floating",
       "label": "Floating capacity",
       "rule": "required",
       "type": "int",
       "control": "Number box",
       "hint": ">= seating",
       "group": "spaces"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "spaces"
      },
      {
       "name": "floor",
       "label": "Floor",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Ground",
        "1",
        "2",
        "Rooftop"
       ],
       "strict": true,
       "group": "spaces"
      },
      {
       "name": "ac",
       "label": "Air conditioning",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Central AC",
        "Split AC",
        "Non-AC"
       ],
       "strict": true,
       "group": "spaces"
      },
      {
       "name": "pillarless",
       "label": "Pillarless",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "notes": "WMG tagline 'Pillarless Convention Hall'.",
       "group": "spaces"
      },
      {
       "name": "has_stage",
       "label": "Stage",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "group": "spaces"
      },
      {
       "name": "dining_area",
       "label": "Separate dining area",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "group": "spaces"
      },
      {
       "name": "changing_room",
       "label": "Attached changing room",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "group": "spaces"
      },
      {
       "name": "rental",
       "label": "Rental for this space",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "hint": "per function",
       "notes": "When halls are priced separately.",
       "group": "spaces"
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "group": "spaces"
      },
      {
       "name": "photos",
       "label": "Linked album",
       "rule": "optional",
       "type": "media",
       "control": "Dropdown of the vendor's albums",
       "hint": "min 1",
       "notes": "WMG links an existing album; not required.",
       "group": "spaces"
      }
     ]
    },
    "packages": {
     "title": "Menus & packages",
     "min": 0,
     "max": 20,
     "fields": [
      {
       "name": "name",
       "label": "Package / menu name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "notes": "VBZ rows 'Veg', 'Non Veg'.",
       "group": "packages"
      },
      {
       "name": "food_type",
       "label": "Menu type",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Veg Standard",
        "Veg Premium",
        "Non-Veg Standard",
        "Non-Veg Premium"
       ],
       "strict": true,
       "group": "packages"
      },
      {
       "name": "price_pp",
       "label": "Price per person",
       "rule": "required",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "group": "packages"
      },
      {
       "name": "taxes_extra",
       "label": "Taxes extra",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "group": "packages"
      },
      {
       "name": "min_guests",
       "label": "Minimum guests",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "group": "packages"
      },
      {
       "name": "cuisines",
       "label": "Cuisines",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "South Indian",
        "Andhra",
        "Hyderabadi",
        "North Indian",
        "Chinese",
        "Continental"
       ],
       "strict": true,
       "group": "packages"
      },
      {
       "name": "service_style",
       "label": "Service style",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Buffet",
        "Plated",
        "Banana-leaf meal"
       ],
       "strict": true,
       "group": "packages"
      },
      {
       "name": "items",
       "label": "Items included",
       "rule": "optional",
       "type": "object",
       "control": "Count dropdown per course (1, 2, 3 ...)",
       "options": [
        "Veg starters",
        "Veg main course",
        "Veg soup / salads",
        "Desserts; non-veg menus add Non-veg starters",
        "Non-veg main course",
        "Non-veg soups / salads",
        "Live counters"
       ],
       "strict": false,
       "notes": "Exact WMG 'Menu Description' block.",
       "group": "packages"
      },
      {
       "name": "menu_file",
       "label": "Menu (PDF / image)",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "PDF / JPG, 10 MB",
       "group": "packages"
      },
      {
       "name": "menu_files",
       "label": "Menu files",
       "rule": "optional",
       "type": "media",
       "control": "Upload tiles ('Add New Menu')",
       "notes": "Separate from the structured menu.",
       "group": "packages"
      }
     ]
    }
   }
  },
  "svc-catering": {
   "key": "svc-catering",
   "module": "service",
   "title": "Catering",
   "category": "Catering",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "food_type",
       "label": "Food served",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Veg only",
        "Veg & non-veg"
       ],
       "strict": true,
       "notes": "WMG 'Veg only => No, both Veg & Non veg'."
      },
      {
       "name": "min_pax",
       "label": "Minimum guests",
       "rule": "required",
       "type": "int",
       "control": "Number box",
       "notes": "'Min 50 pax'."
      },
      {
       "name": "max_pax",
       "label": "Maximum guests",
       "rule": "required",
       "type": "int",
       "control": "Number box",
       "notes": "'Max 10000 pax'."
      },
      {
       "name": "cuisines",
       "label": "Cuisines / speciality",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Vegetarian only",
        "Chaat & Food Stalls",
        "North Indian / Mughlai",
        "South Indian",
        "Continental",
        "Jain",
        "Vegan",
        "Bengali",
        "Kashmiri"
       ],
       "strict": true,
       "notes": "WMG list; add Andhra / Telangana / Hyderabadi for RealRoof."
      },
      {
       "name": "package_items",
       "label": "Standard package includes",
       "rule": "optional",
       "type": "text",
       "control": "Text area or course counters",
       "notes": "WMG: 'Welcome drink, salads, soups, starters, biryani, haleem, desserts'."
      },
      {
       "name": "service_style",
       "label": "Service style",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips",
       "options": [
        "Buffet",
        "Banana-leaf meal",
        "Plated",
        "Live counters"
       ],
       "strict": true
      },
      {
       "name": "staff_included",
       "label": "Serving staff included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "traditional_cooks",
       "label": "Brahmin / traditional cooks (vantalu)",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "notes": "Common ask for Telugu functions."
      },
      {
       "name": "speciality",
       "label": "Catering speciality",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Full service catering",
        "Small function catering",
        "Chaat & fruit stalls",
        "Food counters",
        "Paan",
        "Dessert"
       ],
       "strict": true
      },
      {
       "name": "veg_plate",
       "label": "Veg price per plate",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per plate"
      },
      {
       "name": "nonveg_plate",
       "label": "Non-veg price per plate",
       "rule": "conditional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per plate",
       "notes": "If non-veg served.",
       "when": {
        "field": "food_type",
        "in": [
         "Veg & non-veg"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-dj": {
   "key": "svc-dj",
   "module": "service",
   "title": "DJ",
   "category": "DJ",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "genres",
       "label": "Music genres",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Bollywood",
        "Tollywood",
        "Punjabi",
        "Commercial",
        "Hip hop",
        "House",
        "Retro",
        "Devotional"
       ],
       "strict": true,
       "notes": "Tollywood is our addition."
      },
      {
       "name": "regular_gigs",
       "label": "Regular gigs / clubs",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "equipment",
       "label": "Equipment provided",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Sound system",
        "Console",
        "Lights",
        "LED wall",
        "Fog",
        "Dance floor"
       ],
       "strict": true
      },
      {
       "name": "hours_included",
       "label": "Hours included",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      },
      {
       "name": "price_includes",
       "label": "Price includes",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "notes": "WMG: 'Playing charges along with the console'."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-music-entertainment": {
   "key": "svc-music-entertainment",
   "module": "service",
   "title": "Music & Entertainment",
   "category": "Music & Entertainment",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "performer_type",
       "label": "Performer type",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anchor / Emcee",
        "Live singer",
        "Live band",
        "Guest appearance",
        "Dancers",
        "Guest activity stations",
        "Pyros",
        "Flute artist",
        "Shehnai",
        "Standup comedian (+ RealRoof: Nadaswaram / Mangala vadyam",
        "Dhol",
        "Magician",
        "Kids entertainer)"
       ],
       "strict": true,
       "notes": "WMG 'Type => Live Band'; nadaswaram troupes list here. Nadaswaram troupes list as 'Live Band' on WMG."
      },
      {
       "name": "group_size",
       "label": "Group size",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "notes": "WMG cards show 'N people in the team'."
      },
      {
       "name": "duration_hours",
       "label": "Performance duration (hrs)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box"
      },
      {
       "name": "repertoire",
       "label": "Languages / repertoire",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "Carnatic",
        "Ghazal",
        "Sufi",
        "Western"
       ],
       "strict": true
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-pandit-priest": {
   "key": "svc-pandit-priest",
   "module": "service",
   "title": "Pandit & Priest",
   "category": "Pandit & Priest",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "tradition",
       "label": "Religion / tradition",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Hindu",
        "Muslim",
        "Christian (+ RealRoof: Sikh",
        "Jain; Hindu sub-traditions)"
       ],
       "strict": true,
       "notes": "WMG lists Qazis in the same category. WMG filter 'Culture'."
      },
      {
       "name": "services",
       "label": "Services offered",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Pre-wedding",
        "Wedding",
        "Sagan",
        "Astrology",
        "Muhurtham fixing",
        "Home poojas"
       ],
       "strict": true
      },
      {
       "name": "samagri",
       "label": "Pooja samagri",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Included",
        "Not included",
        "Optional (extra)"
       ],
       "strict": true,
       "notes": "WMG 'Samagri Included'."
      },
      {
       "name": "languages_2",
       "label": "Ceremony languages",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Hindi",
        "Tamil",
        "Telugu",
        "Marathi",
        "Kannada",
        "Punjabi",
        "Bengali",
        "Sanskrit",
        "English",
        "Gujarati",
        "Urdu"
       ],
       "strict": true,
       "notes": "Moved here from common: required for priests."
      },
      {
       "name": "wedding_fee",
       "label": "Wedding ceremony charge",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per ceremony"
      },
      {
       "name": "prewedding_fee",
       "label": "Pre-wedding pooja (engagement / roka)",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per pooja"
      },
      {
       "name": "other_fees",
       "label": "Other ceremonies",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per ceremony",
       "notes": "List: Griha pravesam, Satyanarayana vratham, Upanayanam, Seemantham, Namakaranam, Homam ..."
      },
      {
       "name": "astro_fee",
       "label": "Horoscope matching / astrology",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per person"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-makeup-beautician": {
   "key": "svc-makeup-beautician",
   "module": "service",
   "title": "Makeup & Beautician",
   "category": "Makeup & Beautician",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "speciality",
       "label": "Speciality",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "North Indian",
        "South Indian",
        "Bengali",
        "Muslim",
        "Marathi",
        "Christian",
        "Gujarati",
        "Konkani"
       ],
       "strict": true
      },
      {
       "name": "products",
       "label": "Products used",
       "rule": "optional",
       "type": "object",
       "control": "Chips + other",
       "options": [
        "MAC",
        "Kryolan",
        "Bobbi Brown",
        "Huda",
        "L'Oreal",
        "Other"
       ],
       "strict": false
      },
      {
       "name": "travels_to_venue",
       "label": "Travels to venue",
       "rule": "required",
       "type": "bool",
       "control": "Radio Yes / No",
       "options": [
        "Travels to venue",
        "Doesn't travel to venue"
       ],
       "strict": false
      },
      {
       "name": "trial_policy",
       "label": "Trial policy",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Free trial",
        "Paid trial",
        "Paid trial, adjusted if booked",
        "No trial"
       ],
       "strict": true
      },
      {
       "name": "bridal_price",
       "label": "Bridal makeup",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per function"
      },
      {
       "name": "engagement_price",
       "label": "Engagement makeup",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per function"
      },
      {
       "name": "family_price",
       "label": "Party makeup for family",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per person"
      },
      {
       "name": "outstation_price",
       "label": "Outstation makeup",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per function"
      },
      {
       "name": "includes",
       "label": "Price includes",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Makeup",
        "Hair styling",
        "Saree draping",
        "False lashes",
        "Nail polish change",
        "Jewellery setting"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-mehendi": {
   "key": "svc-mehendi",
   "module": "service",
   "title": "Mehendi",
   "category": "Mehendi",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "styles",
       "label": "Styles",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Traditional",
        "Arabic",
        "Marwari",
        "Rajasthani",
        "Indo-Arabic",
        "Minimal"
       ],
       "strict": true
      },
      {
       "name": "artist_count",
       "label": "Artists available on the day",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper"
      },
      {
       "name": "organic",
       "label": "Organic henna",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "bridal_price",
       "label": "Bridal mehendi",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per bride (both hands & feet)"
      },
      {
       "name": "guest_price",
       "label": "Guest mehendi",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per hand / per person"
      },
      {
       "name": "guest_package_40",
       "label": "Package price (40 hands)",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "hint": "per 40 hands",
       "notes": "WMG's standard guest package unit."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-event-planner": {
   "key": "svc-event-planner",
   "module": "service",
   "title": "Event Planner",
   "category": "Event Planner",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "services",
       "label": "Services",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Full planning",
        "Day-of coordination",
        "Decor",
        "Vendor management",
        "Guest hospitality",
        "Destination weddings",
        "Corporate events",
        "Birthdays"
       ],
       "strict": true
      },
      {
       "name": "decor_policy",
       "label": "Decor policy",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "In-house decor only",
        "Outside decorators",
        "Both"
       ],
       "strict": true
      },
      {
       "name": "cities_done",
       "label": "Cities planned in",
       "rule": "optional",
       "type": "text",
       "control": "Chips (city lookup)"
      },
      {
       "name": "budget_band",
       "label": "Typical budget handled",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "< 5 L",
        "5-15 L",
        "15-50 L",
        "50 L+"
       ],
       "strict": false
      },
      {
       "name": "planning_fee",
       "label": "Planning fee",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      },
      {
       "name": "fee_structure",
       "label": "Fee structure",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Fixed fee",
        "% of total budget",
        "Per day"
       ],
       "strict": true,
       "notes": "WMG 'Charge a Fixed Fee for Planning'."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-decorator": {
   "key": "svc-decorator",
   "module": "service",
   "title": "Decorator",
   "category": "Decorator",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "decor_types",
       "label": "Decor types",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Flower",
        "Balloon",
        "Theme",
        "Lighting",
        "Mandap / stage",
        "Car decoration",
        "Pellikuthuru / pellikoduku set-up"
       ],
       "strict": true,
       "notes": "Telugu set-ups are our addition."
      },
      {
       "name": "experience_zones",
       "label": "Experience zones",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "notes": "WMG 'Most experienced in Celebrity Weddings'."
      },
      {
       "name": "banquet_decor_price",
       "label": "Banquet / hall decor from",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      },
      {
       "name": "home_decor_price",
       "label": "Home function decor from",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      },
      {
       "name": "mandap_price",
       "label": "Mandap / stage decor from",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-photo-video": {
   "key": "svc-photo-video",
   "module": "service",
   "title": "Photo & Video",
   "category": "Photo & Video",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "services",
       "label": "Services",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Candid",
        "Traditional",
        "Cinematic video",
        "Drone",
        "Pre-wedding",
        "Maternity",
        "Live streaming"
       ],
       "strict": true
      },
      {
       "name": "package_days",
       "label": "Package days",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "options": [
        "1",
        "2",
        "3",
        "4 days"
       ],
       "strict": false
      },
      {
       "name": "delivery_weeks",
       "label": "Delivery time (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "notes": "'Delivery time: 4 weeks'."
      },
      {
       "name": "photo_price",
       "label": "Photo package",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per day"
      },
      {
       "name": "photo_video_price",
       "label": "Photo + video package",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per day"
      },
      {
       "name": "prewed_price",
       "label": "Pre-wedding shoot",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per day"
      },
      {
       "name": "album_price",
       "label": "Album",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per 40 pages"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-sangeet-choreographer": {
   "key": "svc-sangeet-choreographer",
   "module": "service",
   "title": "Sangeet Choreographer",
   "category": "Sangeet Choreographer",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "addons",
       "label": "Additional services",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Backup dancers",
        "Props",
        "Costumes",
        "Stage design"
       ],
       "strict": true
      },
      {
       "name": "destination_ok",
       "label": "Open to destination weddings",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per 10 songs"
      },
      {
       "name": "destination_price",
       "label": "Destination wedding price",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-cake": {
   "key": "svc-cake",
   "module": "service",
   "title": "Cake",
   "category": "Cake",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "speciality",
       "label": "Speciality",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Wedding cakes",
        "Cupcakes",
        "Cake in a jar",
        "Eggless",
        "Theme cakes"
       ],
       "strict": true
      },
      {
       "name": "flavours",
       "label": "Popular flavours",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "eggless",
       "label": "Eggless available",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "delivery_policy",
       "label": "Delivery policy",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Free delivery",
        "Delivery at extra cost",
        "Pick-up only"
       ],
       "strict": true
      },
      {
       "name": "price_per_kg",
       "label": "Price per kg",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per kg"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-bartender": {
   "key": "svc-bartender",
   "module": "service",
   "title": "Bartender",
   "category": "Bartender",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "types",
       "label": "Bartender types",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "General",
        "Flair",
        "International"
       ],
       "strict": true
      },
      {
       "name": "fleet",
       "label": "Fleet size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true
      },
      {
       "name": "services",
       "label": "Services provided",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Only bartenders",
        "Glassware",
        "Mixers & garnishes",
        "Ice",
        "Theme-based bar counters"
       ],
       "strict": true
      },
      {
       "name": "price_200",
       "label": "Price for 200 guests",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per 200 guests"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-invitations": {
   "key": "svc-invitations",
   "module": "service",
   "title": "Invitations",
   "category": "Invitations",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "speciality",
       "label": "Speciality",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Boxed",
        "Unboxed",
        "Digital e-cards (+ RealRoof: Traditional",
        "Modern",
        "Laser cut",
        "Video invites)"
       ],
       "strict": true
      },
      {
       "name": "moq",
       "label": "Minimum order quantity",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "shipping",
       "label": "Shipping",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Not available",
        "Domestic",
        "Domestic & international"
       ],
       "strict": true
      },
      {
       "name": "store_type",
       "label": "Store type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Physical store",
        "Online store",
        "Both"
       ],
       "strict": true
      },
      {
       "name": "invite_price",
       "label": "Physical invite price",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per card; or 'Design cost only' / 'On request'",
       "notes": "WMG shows 'On Request' often."
      },
      {
       "name": "einvite_price",
       "label": "E-invite / video invite price",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per design"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-trousseau-packing": {
   "key": "svc-trousseau-packing",
   "module": "service",
   "title": "Trousseau Packing",
   "category": "Trousseau Packing",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "items",
       "label": "Item types",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Hamper baskets",
        "Sagan envelopes",
        "Boxes",
        "Jaimalas & milni malas",
        "Saree bags",
        "Trousseau trunks",
        "Floral / gota jewellery (+ RealRoof: Seer / saare plates)"
       ],
       "strict": true,
       "notes": "Seer plates are our addition."
      },
      {
       "name": "speciality",
       "label": "Speciality",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Wedding gift packing",
        "Fruit basket packing",
        "Bridal trousseau packing",
        "Bridesmaids boxes",
        "Sagan envelopes",
        "Saree gift packing"
       ],
       "strict": true
      },
      {
       "name": "shipping",
       "label": "Shipping",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Not available",
        "Domestic",
        "Domestic & international"
       ],
       "strict": true
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "optional",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per order",
       "notes": "Often 'on request'."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-favors-return-gifts": {
   "key": "svc-favors-return-gifts",
   "module": "service",
   "title": "Favors & Return Gifts",
   "category": "Favors & Return Gifts",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "favor_type",
       "label": "Favor type",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Chocolates",
        "Cookies & biscuits",
        "Personalised",
        "Mithai / sweets",
        "Flavoured tea",
        "Honey, jam & preserves",
        "Dry fruits",
        "Cake in a jar / cupcakes",
        "Silver gifts",
        "Non-edible gifts",
        "Luxury gifting",
        "Mehendi favors",
        "Brownies",
        "Coffee",
        "Candies",
        "Soaps / candles",
        "Macaroons",
        "Accessories",
        "Gift baskets (+ RealRoof: Thamboolam bags",
        "Plants",
        "Brass)"
       ],
       "strict": true,
       "notes": "Thamboolam is our addition."
      },
      {
       "name": "occasions",
       "label": "Occasions",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Invitation gifts",
        "Mehndi favors",
        "Wedding favors / guest gifting",
        "Bridesmaids gifts",
        "Groomsmen gifts",
        "Gifts for bride / groom"
       ],
       "strict": true
      },
      {
       "name": "moq",
       "label": "Minimum order quantity",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "shipping",
       "label": "Shipping",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Not available",
        "Domestic",
        "Domestic & international"
       ],
       "strict": true
      },
      {
       "name": "price_range",
       "label": "Price per piece (min-max)",
       "rule": "required",
       "type": "object",
       "control": "Number box + 'on request' toggle",
       "hint": "per piece"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-tent-house-furniture": {
   "key": "svc-tent-house-furniture",
   "module": "service",
   "title": "Tent House & Furniture",
   "category": "Tent House & Furniture",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "items",
       "label": "Items for rent",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi) + quantity",
       "options": [
        "Shamiana",
        "Pandal",
        "Chairs",
        "Tables",
        "Sofa",
        "Carpets",
        "Coolers / fans",
        "Utensils",
        "Generator"
       ],
       "strict": true,
       "notes": "Not on WMG; common for home / street functions in AP-TS."
      },
      {
       "name": "setup_included",
       "label": "Set-up & removal included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-sound-lighting": {
   "key": "svc-sound-lighting",
   "module": "service",
   "title": "Sound & Lighting",
   "category": "Sound & Lighting",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "equipment",
       "label": "Equipment",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "PA system",
        "Mics",
        "LED wall",
        "Stage lights",
        "Serial lights",
        "Generator"
       ],
       "strict": true
      },
      {
       "name": "operator_included",
       "label": "Operator included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-live-food-counters": {
   "key": "svc-live-food-counters",
   "module": "service",
   "title": "Live Food Counters",
   "category": "Live Food Counters",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "counters",
       "label": "Counters offered",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Dosa",
        "Chaat",
        "Pani puri",
        "Pasta",
        "Tandoor / BBQ",
        "Biryani",
        "Noodles / Chinese",
        "Jalebi",
        "Mocktails",
        "Ice gola",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "food_type",
       "label": "Food served",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Veg only",
        "Veg & non-veg"
       ],
       "strict": true
      },
      {
       "name": "jain",
       "label": "Jain food on request",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "staff_included",
       "label": "Chef & serving staff included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "min_pax",
       "label": "Minimum guests",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "price_per_plate",
       "label": "Price per plate (starting)",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per plate"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-bridal-wear-groom-wear": {
   "key": "svc-bridal-wear-groom-wear",
   "module": "service",
   "title": "Bridal Wear & Groom Wear",
   "category": "Bridal Wear & Groom Wear",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "wear_for",
       "label": "Wear for",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Bride",
        "Groom",
        "Family"
       ],
       "strict": true
      },
      {
       "name": "outfits",
       "label": "Outfits",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Bridal saree",
        "Lehenga",
        "Half saree",
        "Sherwani",
        "Kurta set",
        "Dhoti & pancha",
        "Indo-western",
        "Suit / tuxedo"
       ],
       "strict": true
      },
      {
       "name": "offer",
       "label": "Offered as",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Sale",
        "Rental",
        "Custom stitching"
       ],
       "strict": true
      },
      {
       "name": "trial",
       "label": "Trial before the event",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "alterations",
       "label": "Alterations included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "price_per_outfit",
       "label": "Starting price per outfit",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per outfit"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-photo-booth-services": {
   "key": "svc-photo-booth-services",
   "module": "service",
   "title": "Photo Booth Services",
   "category": "Photo Booth Services",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "booths",
       "label": "Booth types",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Classic photo booth",
        "360° video booth",
        "Mirror booth",
        "GIF / boomerang booth",
        "Theme / flower backdrop"
       ],
       "strict": true
      },
      {
       "name": "instant_prints",
       "label": "Instant prints",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "props",
       "label": "Props included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "soft_copies",
       "label": "Soft copies shared",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "hours",
       "label": "Hours included",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "2 hours",
        "3 hours",
        "4 hours",
        "Full event"
       ],
       "strict": true
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-live-streaming-services": {
   "key": "svc-live-streaming-services",
   "module": "service",
   "title": "Live Streaming Services",
   "category": "Live Streaming Services",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "platforms",
       "label": "Stream to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "YouTube",
        "Facebook",
        "Instagram",
        "Zoom",
        "Private link"
       ],
       "strict": true
      },
      {
       "name": "cameras",
       "label": "Cameras",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2",
        "3",
        "4+"
       ],
       "strict": true
      },
      {
       "name": "recording",
       "label": "Recording handed over",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "internet",
       "label": "Internet",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "We bring our own internet",
        "Venue internet needed"
       ],
       "strict": true
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-ac-cooling-equipment-rental": {
   "key": "svc-ac-cooling-equipment-rental",
   "module": "service",
   "title": "AC & Cooling Equipment Rental",
   "category": "AC & Cooling Equipment Rental",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "equipment",
       "label": "Equipment",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Portable AC",
        "Tower AC",
        "Tent / ducted AC",
        "Air cooler",
        "Mist fan",
        "Pedestal fan",
        "Heater"
       ],
       "strict": true
      },
      {
       "name": "units",
       "label": "Units available",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1-5",
        "5-10",
        "10-25",
        "25+"
       ],
       "strict": true
      },
      {
       "name": "operator_included",
       "label": "Installation & operator included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "power_backup",
       "label": "Generator / power backup available",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "price_per_unit",
       "label": "Starting price per unit per day",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per unit per day"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-event-security-services": {
   "key": "svc-event-security-services",
   "module": "service",
   "title": "Event Security Services",
   "category": "Event Security Services",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "services",
       "label": "Services",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Security guards",
        "Bouncers",
        "Women guards",
        "Valet / parking staff",
        "Crowd control",
        "CCTV",
        "Metal detectors"
       ],
       "strict": true
      },
      {
       "name": "guards",
       "label": "Guards available",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1-5",
        "5-10",
        "10-25",
        "25+"
       ],
       "strict": true
      },
      {
       "name": "licensed",
       "label": "Licensed agency (PSARA)",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "uniformed",
       "label": "Uniformed staff",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "price_per_guard",
       "label": "Price per guard per shift",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per guard per 8-hour shift"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-cleaning-housekeeping": {
   "key": "svc-cleaning-housekeeping",
   "module": "service",
   "title": "Cleaning & Housekeeping",
   "category": "Cleaning & Housekeeping",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "services",
       "label": "Services",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Before the event",
        "During the event",
        "After-event clean-up",
        "Washroom attendants",
        "Waste removal",
        "Deep cleaning"
       ],
       "strict": true
      },
      {
       "name": "staff",
       "label": "Staff available",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1-5",
        "5-10",
        "10-25",
        "25+"
       ],
       "strict": true
      },
      {
       "name": "supplies",
       "label": "Equipment & supplies included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-fireworks-special-effects": {
   "key": "svc-fireworks-special-effects",
   "module": "service",
   "title": "Fireworks & Special Effects",
   "category": "Fireworks & Special Effects",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "effects",
       "label": "Effects",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Aerial fireworks",
        "Cold pyro / sparklers",
        "Confetti blast",
        "CO2 jets",
        "Smoke / fog",
        "Dry-ice entry",
        "Bubble machine",
        "Flower shower"
       ],
       "strict": true
      },
      {
       "name": "indoor_safe",
       "label": "Indoor-safe effects",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "licensed",
       "label": "Licensed; permissions handled",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "operator_included",
       "label": "Operator on site",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "start_price",
       "label": "Starting price",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per event"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-sweet-dessert-counters": {
   "key": "svc-sweet-dessert-counters",
   "module": "service",
   "title": "Sweet & Dessert Counters",
   "category": "Sweet & Dessert Counters",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "counters",
       "label": "Counters offered",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Traditional sweets",
        "Live jalebi",
        "Ice cream",
        "Kulfi",
        "Chocolate fountain",
        "Pastries & cakes",
        "Paan",
        "Cotton candy"
       ],
       "strict": true
      },
      {
       "name": "eggless",
       "label": "Eggless options",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "staff_included",
       "label": "Serving staff included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "min_pax",
       "label": "Minimum guests",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "price_per_plate",
       "label": "Price per plate (starting)",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per plate"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "svc-transportation-guest-mobility": {
   "key": "svc-transportation-guest-mobility",
   "module": "service",
   "title": "Transportation & Guest Mobility",
   "category": "Transportation & Guest Mobility",
   "sections": [
    {
     "key": "business",
     "title": "Business",
     "fields": [
      {
       "name": "name",
       "label": "Business / artist name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "3-80 chars"
      },
      {
       "name": "category_id",
       "label": "Service category",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "hint": "See Category Map",
       "notes": "One profile per category; a firm offering decor + planning lists twice (WMG does this).",
       "options": [
        "Catering",
        "DJ",
        "Music & Entertainment",
        "Pandit & Priest",
        "Makeup & Beautician",
        "Mehendi",
        "Event Planner",
        "Decorator",
        "Photo & Video",
        "Sangeet Choreographer",
        "Cake",
        "Bartender",
        "Invitations",
        "Trousseau Packing",
        "Favors & Return Gifts",
        "Tent House & Furniture",
        "Sound & Lighting",
        "Live Food Counters",
        "Bridal Wear & Groom Wear",
        "Photo Booth Services",
        "Live Streaming Services",
        "AC & Cooling Equipment Rental",
        "Event Security Services",
        "Cleaning & Housekeeping",
        "Fireworks & Special Effects",
        "Sweet & Dessert Counters",
        "Transportation & Guest Mobility"
       ],
       "strict": true
      },
      {
       "name": "business_type",
       "label": "Business type",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Freelancer",
        "Studio / salon",
        "Company"
       ],
       "strict": true,
       "notes": "WMG makeup: 'Freelance Artist'."
      },
      {
       "name": "start_year",
       "label": "Experience / started in",
       "rule": "optional",
       "type": "object",
       "control": "Year picker",
       "options": [
        "Since YYYY",
        "<1",
        "1-3",
        "3-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": false,
       "notes": "WMG mixes 'Since 2012' and '3-5 years'; store the year. WMG filter bands: 1-3 / 3-5 / 5-10 / 10+."
      },
      {
       "name": "team_size",
       "label": "Team size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1",
        "2-5",
        "5-10",
        "10-20",
        "20+"
       ],
       "strict": true,
       "notes": "WMG bartenders: 'Bartender Fleet 10-20'."
      },
      {
       "name": "languages",
       "label": "Languages spoken",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Telugu",
        "Hindi",
        "English",
        "Urdu",
        "Tamil",
        "Kannada",
        "Sanskrit"
       ],
       "strict": true,
       "notes": "Seen for pandits; useful for all."
      },
      {
       "name": "usp",
       "label": "USP / speciality line",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 200 chars",
       "notes": "WMG 'USP', 'Style USP', 'Core Speciality'."
      },
      {
       "name": "notable_events",
       "label": "Celebrity / notable events",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 300 chars"
      },
      {
       "name": "awards",
       "label": "Awards",
       "rule": "optional",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "description",
       "label": "About",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me'",
       "hint": "100-3000 chars"
      }
     ]
    },
    {
     "key": "details-pricing",
     "title": "Details & Pricing",
     "fields": [
      {
       "name": "vehicles",
       "label": "Vehicles",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Luxury cars",
        "Vintage cars",
        "Decorated car",
        "Sedans",
        "SUVs",
        "Tempo travellers",
        "Mini buses",
        "Buses",
        "Horse / baggi"
       ],
       "strict": true
      },
      {
       "name": "fleet",
       "label": "Fleet size",
       "rule": "optional",
       "type": "enum",
       "control": "Chips",
       "options": [
        "1-5",
        "5-10",
        "10-25",
        "25+"
       ],
       "strict": true
      },
      {
       "name": "driver_included",
       "label": "Driver included",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "pickups",
       "label": "Airport / station pick-ups",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "coordinator",
       "label": "Guest movement coordinator",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle"
      },
      {
       "name": "price_per_vehicle",
       "label": "Starting price per vehicle per day",
       "rule": "required",
       "type": "money",
       "control": "Number box + 'on request' toggle",
       "hint": "per vehicle per day"
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_name",
       "label": "Contact person",
       "rule": "required",
       "type": "text",
       "control": "Text box"
      },
      {
       "name": "mobile",
       "label": "Mobile",
       "rule": "required",
       "type": "phone",
       "control": "Number + OTP",
       "hint": "+91, 10 digits"
      },
      {
       "name": "whatsapp",
       "label": "WhatsApp",
       "rule": "optional",
       "type": "phone",
       "control": "Toggle 'same as mobile'"
      },
      {
       "name": "email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box"
      },
      {
       "name": "links",
       "label": "Website / Instagram / YouTube",
       "rule": "optional",
       "type": "media",
       "control": "Text boxes",
       "notes": "Instagram is the main portfolio for most vendors."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "Base city",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown"
      },
      {
       "name": "base_location",
       "label": "Locality / studio address",
       "rule": "optional",
       "type": "object",
       "control": "Autocomplete + text",
       "notes": "Studios / shops show an address; freelancers may hide it."
      },
      {
       "name": "travel_scope",
       "label": "Travels to",
       "rule": "required",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Travels same city",
        "Travels domestic",
        "Travels international",
        "Cannot travel"
       ],
       "strict": true,
       "notes": "WMG: 'Travels Same City, Travels Domestic'."
      },
      {
       "name": "outstation_cost",
       "label": "Outstation travel & stay",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Borne by client",
        "Included",
        "Extra charge (amount)"
       ],
       "strict": true,
       "notes": "WMG photographers."
      }
     ]
    },
    {
     "key": "events",
     "title": "Events",
     "fields": [
      {
       "name": "events",
       "label": "Events served",
       "rule": "required",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "Engagement",
        "Wedding",
        "Reception",
        "Sangeet / Mehendi",
        "Haldi",
        "Pellikuthuru / Pellikoduku",
        "Seemantham / Baby shower",
        "Namakaranam",
        "Cradle ceremony",
        "Annaprasana",
        "Half saree",
        "Dhoti function",
        "Upanayanam",
        "Griha pravesam",
        "Satyanarayana vratham",
        "Birthday",
        "Anniversary",
        "Corporate",
        "Get-together"
       ],
       "strict": true,
       "notes": "WMG entertainment lists Roka, Wedding, Sagan, Cocktail, Private party."
      }
     ]
    },
    {
     "key": "booking-terms",
     "title": "Booking terms",
     "fields": [
      {
       "name": "lead_time_weeks",
       "label": "Book in advance (weeks)",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-52",
       "notes": "WMG: 'Book 2 weeks in advance'."
      },
      {
       "name": "advance_pct",
       "label": "Advance payment",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "hint": "0-100 %",
       "notes": "WMG: '25 % Advance', 'Takes 50% Advance'."
      },
      {
       "name": "cancel_by_customer",
       "label": "Cancellation by customer",
       "rule": "required",
       "type": "object",
       "control": "Radio + text area",
       "options": [
        "Full refund",
        "Partial refund",
        "No refund, date can be moved",
        "No refund"
       ],
       "strict": false,
       "notes": "WMG asks both sides ('Cancellation Policy - User' / '-Self')."
      },
      {
       "name": "cancel_by_vendor",
       "label": "Cancellation by vendor",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Full refund",
        "Partial refund"
       ],
       "strict": true
      },
      {
       "name": "cancel_terms",
       "label": "Cancellation terms",
       "rule": "optional",
       "type": "text",
       "control": "Text area",
       "hint": "max 500 chars",
       "notes": "Free text, e.g. '10% deducted if client cancels'."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "cover_photo",
       "label": "Profile / cover photo",
       "rule": "required",
       "type": "media",
       "control": "Upload + crop",
       "accept": "image"
      },
      {
       "name": "photos",
       "label": "Portfolio photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "min 5",
       "accept": "image"
      },
      {
       "name": "albums",
       "label": "Albums / projects",
       "rule": "optional",
       "type": "media",
       "control": "Album builder",
       "hint": "title, event, venue, photos",
       "notes": "WMG 'Projects' tab."
      },
      {
       "name": "videos",
       "label": "Videos",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "created_at",
       "label": "On platform since",
       "rule": "system",
       "type": "datetime",
       "control": "-",
       "notes": "'Been on WedMeGood since ...' is shown on every profile."
      },
      {
       "name": "stats",
       "label": "Rating, reviews, enquiries",
       "rule": "system",
       "type": "object",
       "control": "-"
      },
      {
       "name": "plan",
       "label": "Plan / badge",
       "rule": "system",
       "type": "enum",
       "control": "-",
       "options": [
        "Free",
        "Premium",
        "Handpicked"
       ],
       "strict": true
      }
     ]
    }
   ],
   "groups": {}
  },
  "com-other-sell": {
   "key": "com-other-sell",
   "module": "property",
   "title": "Com Other Sell",
   "purpose": "sell",
   "category": "commercial",
   "property_types": [
    "Other"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Other"
       ],
       "strict": true,
       "notes": "Pre-selected: Retail. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "What kind of property is it?",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. Petrol pump, School building, Hospital, Showroom with godown"
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Mall / complex name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      },
      {
       "name": "entrance_width",
       "label": "Entrance width",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "ceiling_height",
       "label": "Ceiling height",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "located_near",
       "label": "Located near",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Entrance",
        "Elevator",
        "Stairs"
       ],
       "strict": true
      },
      {
       "name": "suitable_business",
       "label": "Suitable for",
       "rule": "optional",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "ATM",
        "Bakery",
        "Boutique",
        "Clinic",
        "Clothes",
        "Café",
        "Electronics",
        "Pharmacy",
        "Restaurant",
        "Salon",
        "Other"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      },
      {
       "name": "staircases",
       "label": "Staircases",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "lifts",
       "label": "Lifts",
       "rule": "optional",
       "type": "object",
       "control": "Two number steppers",
       "hint": "0-20"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "ownership",
       "label": "Ownership",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Freehold",
        "Leasehold",
        "Co-operative society",
        "Power of attorney"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "price",
     "title": "Price",
     "fields": [
      {
       "name": "price",
       "label": "Expected price",
       "rule": "required",
       "type": "money",
       "control": "Number box with Lakh/Crore helper",
       "hint": "> 0",
       "notes": "Show the amount in words (e.g. 2.05 Crore) under the box."
      },
      {
       "name": "price_per_unit",
       "label": "Price per sq.ft",
       "rule": "system",
       "type": "money",
       "control": "Auto-calculated",
       "hint": "price / area",
       "notes": "Read-only; flag outliers vs locality average."
      },
      {
       "name": "price_all_inclusive",
       "label": "All-inclusive price",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "tax_excluded",
       "label": "Tax & govt. charges excluded",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "price_negotiable",
       "label": "Price negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance",
       "label": "Maintenance",
       "rule": "optional",
       "type": "measure",
       "control": "Number + dropdown",
       "options": [
        "Monthly",
        "Quarterly",
        "Yearly",
        "One-time",
        "Per sq.ft monthly"
       ],
       "strict": false
      },
      {
       "name": "booking_amount",
       "label": "Booking / token amount",
       "rule": "optional",
       "type": "money",
       "control": "Number box"
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio (None / % / fixed) + number + checkbox",
       "options": [
        "% of price",
        "Fixed amount"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "is_pre_leased",
       "label": "Pre-leased / pre-rented",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No",
       "notes": "Investor filter."
      },
      {
       "name": "pre_lease_rent",
       "label": "Current rent",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "per month",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_tenure",
       "label": "Lease tenure",
       "rule": "conditional",
       "type": "int",
       "control": "Number + unit (years)",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": true
      },
      {
       "name": "pre_lease_increment_pct",
       "label": "Annual rent increase",
       "rule": "conditional",
       "type": "decimal",
       "control": "Number box",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_leased_to",
       "label": "Leased to (business)",
       "rule": "conditional",
       "type": "text",
       "control": "Text box + 'hide' toggle",
       "notes": "If pre-leased.",
       "when": {
        "field": "is_pre_leased",
        "equals": true
       },
       "required_when_shown": false
      },
      {
       "name": "pre_lease_annual_return",
       "label": "Annual return %",
       "rule": "system",
       "type": "decimal",
       "control": "Auto-calculated",
       "hint": "rent x 12 / price",
       "notes": "Owner may hide it (99acres has the flag)."
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "com-other-rent": {
   "key": "com-other-rent",
   "module": "property",
   "title": "Com Other Rent",
   "purpose": "rent",
   "category": "commercial",
   "property_types": [
    "Other"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Rent. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Other"
       ],
       "strict": true,
       "notes": "Pre-selected: Retail. Show 4 + 'more' on mobile."
      },
      {
       "name": "property_subtype",
       "label": "What kind of property is it?",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. Petrol pump, School building, Hospital, Showroom with godown"
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Owner",
        "Agent / Dealer",
        "Builder"
       ],
       "strict": true,
       "notes": "Default from the user profile; drives brokerage + RERA agent fields."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Mall / complex name",
       "rule": "optional",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "unit_no",
       "label": "House / flat / plot no.",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 30 chars",
       "notes": "Never shown publicly (hideAddress)."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "area",
     "title": "Area",
     "fields": [
      {
       "name": "carpet_area",
       "label": "Carpet area",
       "rule": "required",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "At least carpet OR built-up OR super built-up must be filled; carpet is the RERA standard."
      },
      {
       "name": "builtup_area",
       "label": "Built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false
      },
      {
       "name": "super_builtup_area",
       "label": "Super built-up area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit dropdown",
       "options": [
        "sqft",
        "sqyd",
        "sq.m",
        "acres",
        "cents",
        "guntha",
        "grounds"
       ],
       "strict": false,
       "notes": "Must be >= built-up >= carpet."
      }
     ]
    },
    {
     "key": "details",
     "title": "Details",
     "fields": [
      {
       "name": "total_floors",
       "label": "Total floors in building",
       "rule": "required",
       "type": "int",
       "control": "Number stepper",
       "hint": "1-200"
      },
      {
       "name": "floor_no",
       "label": "Property on floor",
       "rule": "required",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Lower basement",
        "Upper basement",
        "Ground",
        "1 ... total floors"
       ],
       "strict": false,
       "notes": "Must be <= total floors."
      },
      {
       "name": "entrance_width",
       "label": "Entrance width",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "ceiling_height",
       "label": "Ceiling height",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit (ft / m)"
      },
      {
       "name": "located_near",
       "label": "Located near",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Entrance",
        "Elevator",
        "Stairs"
       ],
       "strict": true
      },
      {
       "name": "suitable_business",
       "label": "Suitable for",
       "rule": "optional",
       "type": "enum_list",
       "control": "Searchable multi-select",
       "options": [
        "ATM",
        "Bakery",
        "Boutique",
        "Clinic",
        "Clothes",
        "Café",
        "Electronics",
        "Pharmacy",
        "Restaurant",
        "Salon",
        "Other"
       ],
       "strict": true
      }
     ]
    },
    {
     "key": "features",
     "title": "Features",
     "fields": [
      {
       "name": "zone_type",
       "label": "Zone type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Commercial",
        "Industrial",
        "Residential",
        "Special Economic Zone",
        "Open space",
        "Agricultural",
        "Other"
       ],
       "strict": true
      },
      {
       "name": "washrooms",
       "label": "Washrooms",
       "rule": "optional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "None",
        "Shared",
        "1",
        "2",
        "3+ (private)"
       ],
       "strict": true
      },
      {
       "name": "has_fire_noc",
       "label": "Fire NOC",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "has_oc",
       "label": "Occupancy certificate",
       "rule": "optional",
       "type": "bool",
       "control": "Radio Yes / No"
      },
      {
       "name": "fire_safety",
       "label": "Fire safety measures",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi)",
       "options": [
        "Fire extinguisher",
        "Sprinklers",
        "Fire sensors",
        "Fire hose"
       ],
       "strict": true
      },
      {
       "name": "power_backup",
       "label": "Power backup",
       "rule": "optional",
       "type": "enum",
       "control": "Radio",
       "options": [
        "None",
        "DG backup",
        "Need to arrange"
       ],
       "strict": true
      },
      {
       "name": "parking",
       "label": "Parking",
       "rule": "optional",
       "type": "object",
       "control": "Chips (multi) + number",
       "options": [
        "Private basement",
        "Private open",
        "Public",
        "Multilevel"
       ],
       "strict": false
      },
      {
       "name": "staircases",
       "label": "Staircases",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-10"
      },
      {
       "name": "lifts",
       "label": "Lifts",
       "rule": "optional",
       "type": "object",
       "control": "Two number steppers",
       "hint": "0-20"
      }
     ]
    },
    {
     "key": "status",
     "title": "Status",
     "fields": [
      {
       "name": "availability",
       "label": "Availability",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Ready to move",
        "Under construction"
       ],
       "strict": true
      },
      {
       "name": "age_band",
       "label": "Age of property",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "0-1",
        "1-5",
        "5-10",
        "10+ yrs"
       ],
       "strict": true,
       "notes": "If ready.",
       "when": {
        "field": "availability",
        "in": [
         "Ready to move"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "notes": "If under construction.",
       "when": {
        "field": "availability",
        "in": [
         "Under construction"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "rent",
     "title": "Rent",
     "fields": [
      {
       "name": "rent_or_lease",
       "label": "Property available for",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Only rent",
        "Only lease"
       ],
       "strict": true,
       "notes": "'Only lease' replaces rent + deposit with one 'Expected lease amount'."
      },
      {
       "name": "rent_amount",
       "label": "Expected rent (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box (shows 20k-style hint)",
       "hint": "> 0",
       "notes": "If 'Only rent'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "deposit_amount",
       "label": "Expected deposit",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": ">= 0",
       "notes": "If 'Only rent'. NoBroker asks a plain amount (no 'months of rent' option).",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only rent"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "lease_amount",
       "label": "Expected lease amount",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "hint": "> 0",
       "notes": "If 'Only lease'.",
       "when": {
        "field": "rent_or_lease",
        "in": [
         "Only lease"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "rent_negotiable",
       "label": "Rent negotiable",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox"
      },
      {
       "name": "maintenance_mode",
       "label": "Monthly maintenance",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Maintenance included",
        "Maintenance extra"
       ],
       "strict": true
      },
      {
       "name": "maintenance_amount",
       "label": "Maintenance amount (per month)",
       "rule": "conditional",
       "type": "money",
       "control": "Number box",
       "notes": "Required when 'Maintenance extra'.",
       "when": {
        "field": "maintenance_mode",
        "in": [
         "Maintenance extra"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "available_from",
       "label": "Available from",
       "rule": "required",
       "type": "date",
       "control": "Date picker",
       "hint": ">= today"
      },
      {
       "name": "utilities_included",
       "label": "Electricity & water included",
       "rule": "optional",
       "type": "bool",
       "control": "Checkbox",
       "notes": "Not on NoBroker; keep as optional."
      },
      {
       "name": "lock_in_months",
       "label": "Lock-in period",
       "rule": "optional",
       "type": "int",
       "control": "Number stepper",
       "hint": "0-36 months",
       "notes": "Not on NoBroker form."
      },
      {
       "name": "notice_months",
       "label": "Notice period",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "None",
        "1",
        "2",
        "3 months"
       ],
       "strict": true,
       "notes": "Not on NoBroker form."
      },
      {
       "name": "brokerage",
       "label": "Brokerage",
       "rule": "conditional",
       "type": "object",
       "control": "Radio + number",
       "options": [
        "None",
        "15 days",
        "1 month rent",
        "Custom"
       ],
       "strict": false,
       "notes": "Only for Agent / Dealer (NoBroker is owner-only, so it has no brokerage field).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Key highlights (USPs)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Corner",
        "Vastu compliant",
        "Park facing",
        "Newly renovated"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing."
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 10,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    }
   }
  },
  "res-project-sell": {
   "key": "res-project-sell",
   "module": "property",
   "title": "Res New Project Sell",
   "purpose": "sell",
   "category": "residential",
   "property_types": [
    "New project"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Residential. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "New project"
       ],
       "strict": true,
       "notes": "Pre-selected: Flat / Apartment. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Builder",
        "Agent / Dealer"
       ],
       "strict": true,
       "notes": "Set from the verified builder / agent account."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project name",
       "rule": "required",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "project",
     "title": "Project",
     "fields": [
      {
       "name": "project_kind",
       "label": "What is the project?",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Apartments",
        "Villas",
        "Plots",
        "Independent floors",
        "Apartments & villas",
        "Mixed"
       ],
       "strict": true
      },
      {
       "name": "availability",
       "label": "Project status",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New launch",
        "Under construction",
        "Ready to move"
       ],
       "strict": true
      },
      {
       "name": "launch_date",
       "label": "Launched in",
       "rule": "optional",
       "type": "month",
       "control": "Month-year picker"
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "when": {
        "field": "availability",
        "in": [
         "New launch",
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "As on the state RERA certificate"
      },
      {
       "name": "towers",
       "label": "Towers / blocks",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "total_floors",
       "label": "Floors (tallest tower)",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "total_units",
       "label": "Total units",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "land_area",
       "label": "Project land area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit",
       "options": [
        "acres",
        "sqft",
        "sqyd",
        "sq.m",
        "guntha",
        "cents"
       ]
      },
      {
       "name": "open_area_pct",
       "label": "Open area (%)",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      }
     ]
    },
    {
     "key": "amenities",
     "title": "Amenities",
     "fields": [
      {
       "name": "society_amenities",
       "label": "Project amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      }
     ]
    },
    {
     "key": "specifications",
     "title": "Specifications",
     "fields": [
      {
       "name": "spec_structure",
       "label": "Structure",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_walls",
       "label": "Walls / brickwork",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_kitchen",
       "label": "Kitchen",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_bathrooms",
       "label": "Bathrooms",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_doors_windows",
       "label": "Doors & windows",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_electrical",
       "label": "Electrical",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_water",
       "label": "Water supply",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_other",
       "label": "Other",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Why buy here (highlights)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Near a metro station",
        "Near the airport",
        "Near an IT hub",
        "Near schools and hospitals",
        "Lake / park view",
        "Wide internal roads",
        "Large clubhouse",
        "Vastu compliant"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing.",
       "hint": "Up to 5 short lines, e.g. 1.2 km from the airport"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "unit_types": {
     "title": "Unit types",
     "min": 1,
     "max": 20,
     "fields": [
      {
       "name": "unit_kind",
       "label": "Unit type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Apartment",
        "Villa",
        "Independent floor",
        "Penthouse",
        "Studio",
        "Plot"
       ],
       "strict": true,
       "group": "unit_types"
      },
      {
       "name": "bedrooms",
       "label": "Bedrooms (BHK)",
       "rule": "conditional",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6+"
       ],
       "strict": true,
       "when": {
        "field": "unit_kind",
        "in": [
         "Apartment",
         "Villa",
         "Independent floor",
         "Penthouse"
        ]
       },
       "required_when_shown": true,
       "group": "unit_types"
      },
      {
       "name": "area_kind",
       "label": "Area shown as",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Super built-up area",
        "Built-up area",
        "Carpet area",
        "Plot area"
       ],
       "strict": true,
       "group": "unit_types"
      },
      {
       "name": "area_min",
       "label": "Area from (sq.ft)",
       "rule": "required",
       "type": "int",
       "control": "Number box",
       "group": "unit_types"
      },
      {
       "name": "area_max",
       "label": "Area up to (sq.ft)",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "notes": "Leave empty when every unit of this type has the same area.",
       "group": "unit_types"
      },
      {
       "name": "price_min",
       "label": "Price from",
       "rule": "required",
       "type": "money",
       "control": "Number box",
       "group": "unit_types"
      },
      {
       "name": "price_max",
       "label": "Price up to",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "group": "unit_types"
      },
      {
       "name": "price_note",
       "label": "Price note",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. + GST and registration",
       "group": "unit_types"
      },
      {
       "name": "units",
       "label": "Units of this type",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "group": "unit_types"
      }
     ]
    },
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 30,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "for_unit",
       "label": "For unit type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "notes": "Groups the plans by unit type on the project page.",
       "options": [
        "1 BHK",
        "2 BHK",
        "3 BHK",
        "4 BHK",
        "5 BHK",
        "6+ BHK",
        "Studio",
        "Plot"
       ],
       "strict": true,
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    },
    "nearby": {
     "title": "Nearby places",
     "min": 0,
     "max": 15,
     "fields": [
      {
       "name": "place",
       "label": "Place",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. Airport, Metro station, School",
       "group": "nearby"
      },
      {
       "name": "distance_km",
       "label": "Distance (km)",
       "rule": "required",
       "type": "decimal",
       "control": "Number box",
       "group": "nearby"
      }
     ]
    },
    "progress": {
     "title": "Construction updates",
     "min": 0,
     "max": 36,
     "fields": [
      {
       "name": "month",
       "label": "Month",
       "rule": "required",
       "type": "month",
       "control": "Month-year picker",
       "group": "progress"
      },
      {
       "name": "photos",
       "label": "Site photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "Up to 12 photos of the site this month",
       "accept": "image",
       "max": 12,
       "group": "progress"
      },
      {
       "name": "note",
       "label": "What was done",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. Tower A slab up to the 10th floor; max 200 chars",
       "group": "progress"
      }
     ]
    }
   },
   "project": true
  },
  "com-project-sell": {
   "key": "com-project-sell",
   "module": "property",
   "title": "Com New Project Sell",
   "purpose": "sell",
   "category": "commercial",
   "property_types": [
    "New project"
   ],
   "subtypes": [],
   "sections": [
    {
     "key": "basic",
     "title": "Basic",
     "fields": [
      {
       "name": "listing_purpose",
       "label": "You're looking to",
       "rule": "required",
       "type": "enum",
       "control": "Segmented buttons",
       "options": [
        "Sell",
        "Rent / Lease",
        "PG"
       ],
       "strict": true,
       "notes": "Pre-selected: Sell. PG only shown for Residential."
      },
      {
       "name": "res_com",
       "label": "Property category",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Residential",
        "Commercial"
       ],
       "strict": true,
       "notes": "Pre-selected: Commercial. Changing it resets property type."
      },
      {
       "name": "property_type",
       "label": "Property type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "New project"
       ],
       "strict": true,
       "notes": "Pre-selected: Office. Show 4 + 'more' on mobile."
      },
      {
       "name": "posted_by",
       "label": "Posted by",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Builder",
        "Agent / Dealer"
       ],
       "strict": true,
       "notes": "Set from the verified builder / agent account."
      }
     ]
    },
    {
     "key": "contact",
     "title": "Contact",
     "fields": [
      {
       "name": "contact_mobile",
       "label": "Mobile number",
       "rule": "required",
       "type": "phone",
       "control": "Country code dropdown + number",
       "hint": "+91 default; 10 digits for India",
       "notes": "OTP verified before step 2 (99acres gates the form here)."
      },
      {
       "name": "contact_name",
       "label": "Contact name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "2-60 chars",
       "notes": "Prefill from profile."
      },
      {
       "name": "contact_email",
       "label": "Email",
       "rule": "optional",
       "type": "email",
       "control": "Text box",
       "hint": "RFC email",
       "notes": "Masked publicly; leads mailed here."
      },
      {
       "name": "whatsapp_same",
       "label": "WhatsApp same as mobile",
       "rule": "optional",
       "type": "bool",
       "control": "Toggle",
       "hint": "Default ON",
       "notes": "If OFF show a second phone box."
      },
      {
       "name": "company_name",
       "label": "Company / agency name",
       "rule": "conditional",
       "type": "text",
       "control": "Text box",
       "hint": "Required if Agent/Builder",
       "notes": "Shown on the dealer card.",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer",
         "Builder"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "agent_rera_no",
       "label": "Agent RERA registration no.",
       "rule": "conditional",
       "type": "enum",
       "control": "Text box + status dropdown",
       "options": [
        "Status: Registered",
        "Applied for",
        "Not applicable"
       ],
       "strict": true,
       "notes": "Required for agents in RERA states (Telangana, AP, etc.).",
       "when": {
        "field": "posted_by",
        "in": [
         "Agent / Dealer"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "contact_time",
       "label": "Preferred contact time",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "options": [
        "Anytime",
        "Morning",
        "Afternoon",
        "Evening"
       ],
       "strict": true,
       "notes": "Nice-to-have."
      }
     ]
    },
    {
     "key": "location",
     "title": "Location",
     "fields": [
      {
       "name": "city_id",
       "label": "City",
       "rule": "required",
       "type": "location",
       "control": "Searchable dropdown",
       "hint": "City master",
       "notes": "Default to user's city; start with Telangana / AP cities."
      },
      {
       "name": "locality_id",
       "label": "Locality",
       "rule": "required",
       "type": "location",
       "control": "Autocomplete (filtered by city)",
       "hint": "Locality master + 'add new' (moderated)",
       "notes": "Drives search and price trends."
      },
      {
       "name": "project_name",
       "label": "Project name",
       "rule": "required",
       "type": "text",
       "control": "Autocomplete with free text",
       "hint": "Project master; free text if not found",
       "notes": "Link to project master when matched."
      },
      {
       "name": "address_line",
       "label": "Street / landmark",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 120 chars"
      },
      {
       "name": "pincode",
       "label": "PIN code",
       "rule": "optional",
       "type": "pincode",
       "control": "Number box",
       "notes": "Auto-fill from map pin when possible."
      },
      {
       "name": "geo",
       "label": "Map pin",
       "rule": "optional",
       "type": "geo",
       "control": "Map picker",
       "hint": "Inside the chosen city boundary",
       "notes": "Default to locality centroid; drives 'places nearby'."
      }
     ]
    },
    {
     "key": "project",
     "title": "Project",
     "fields": [
      {
       "name": "project_kind",
       "label": "What is the project?",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Offices",
        "Shops / Retail",
        "Offices & shops",
        "Commercial plots",
        "Mixed"
       ],
       "strict": true
      },
      {
       "name": "availability",
       "label": "Project status",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "New launch",
        "Under construction",
        "Ready to move"
       ],
       "strict": true
      },
      {
       "name": "launch_date",
       "label": "Launched in",
       "rule": "optional",
       "type": "month",
       "control": "Month-year picker"
      },
      {
       "name": "possession_date",
       "label": "Possession by",
       "rule": "conditional",
       "type": "month",
       "control": "Month-year picker",
       "when": {
        "field": "availability",
        "in": [
         "New launch",
         "Under construction"
        ]
       },
       "required_when_shown": true
      },
      {
       "name": "project_rera_no",
       "label": "Project RERA no.",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "As on the state RERA certificate"
      },
      {
       "name": "towers",
       "label": "Towers / blocks",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "total_floors",
       "label": "Floors (tallest tower)",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "total_units",
       "label": "Total units",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      },
      {
       "name": "land_area",
       "label": "Project land area",
       "rule": "optional",
       "type": "measure",
       "control": "Number + unit",
       "options": [
        "acres",
        "sqft",
        "sqyd",
        "sq.m",
        "guntha",
        "cents"
       ]
      },
      {
       "name": "open_area_pct",
       "label": "Open area (%)",
       "rule": "optional",
       "type": "int",
       "control": "Number box"
      }
     ]
    },
    {
     "key": "amenities",
     "title": "Amenities",
     "fields": [
      {
       "name": "society_amenities",
       "label": "Project amenities",
       "rule": "optional",
       "type": "enum_list",
       "control": "Icon chips (multi)",
       "options": [
        "Swimming pool",
        "Gymnasium",
        "Club house",
        "Park",
        "Children's play area",
        "Shopping centre",
        "CCTV surveillance",
        "24x7 security",
        "Lift(s)",
        "DG availability",
        "Water softening plant",
        "Rain water harvesting",
        "Visitor parking",
        "Jogging track",
        "Indoor games",
        "Multipurpose hall"
       ],
       "strict": true,
       "notes": "Prefill from project master when the project is matched."
      }
     ]
    },
    {
     "key": "specifications",
     "title": "Specifications",
     "fields": [
      {
       "name": "spec_structure",
       "label": "Structure",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_walls",
       "label": "Walls / brickwork",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_flooring",
       "label": "Flooring",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_kitchen",
       "label": "Kitchen",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_bathrooms",
       "label": "Bathrooms",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_doors_windows",
       "label": "Doors & windows",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_electrical",
       "label": "Electrical",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_water",
       "label": "Water supply",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      },
      {
       "name": "spec_other",
       "label": "Other",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "max 300 chars"
      }
     ]
    },
    {
     "key": "media",
     "title": "Media",
     "fields": [
      {
       "name": "photos",
       "label": "Photos",
       "rule": "optional",
       "type": "media",
       "control": "Multi-upload with drag-sort",
       "hint": "JPG/PNG/HEIC, up to 10 MB each, max 50",
       "notes": "Strongly prompt: listings with photos get more leads. Tag each photo (Bedroom, Kitchen, Exterior...). First = cover.",
       "accept": "image"
      },
      {
       "name": "videos",
       "label": "Video",
       "rule": "optional",
       "type": "media",
       "control": "Upload or YouTube link",
       "hint": "MP4 up to 100 MB, max 3",
       "accept": "video"
      },
      {
       "name": "brochure",
       "label": "Brochure",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One PDF, up to 10 MB",
       "max": 1,
       "notes": "Shown on the ad as a 'Brochure' download.",
       "accept": "document"
      }
     ]
    },
    {
     "key": "description",
     "title": "Description",
     "fields": [
      {
       "name": "title",
       "label": "Ad title",
       "rule": "system",
       "type": "text",
       "control": "Auto-generated",
       "hint": "e.g. '3 BHK Flat for Sale in Tellapur'",
       "notes": "Generated from type + BHK + locality; owner may not edit (SEO)."
      },
      {
       "name": "description",
       "label": "Description",
       "rule": "required",
       "type": "text_long",
       "control": "Text area + 'write for me' button",
       "hint": "30-5000 chars; no phone numbers / URLs",
       "notes": "Offer an AI-drafted description from the entered fields."
      },
      {
       "name": "usp_ids",
       "label": "Why buy here (highlights)",
       "rule": "optional",
       "type": "enum_list",
       "control": "Chips (multi, max 5)",
       "options": [
        "Near a metro station",
        "Near the airport",
        "Near an IT hub",
        "Near schools and hospitals",
        "Lake / park view",
        "Wide internal roads",
        "Large clubhouse",
        "Vastu compliant"
       ],
       "strict": false,
       "notes": "Shown as bullets on the listing.",
       "hint": "Up to 5 short lines, e.g. 1.2 km from the airport"
      }
     ]
    },
    {
     "key": "system",
     "title": "System",
     "fields": [
      {
       "name": "listing_id",
       "label": "Listing ID",
       "rule": "system",
       "type": "text",
       "control": "-",
       "hint": "e.g. RR-SALE-000123",
       "notes": "Generated on submit."
      },
      {
       "name": "timestamps",
       "label": "Posted / modified / expiry date",
       "rule": "system",
       "type": "object",
       "control": "-",
       "hint": "Expiry = posted + 60 days (99acres listing showed ~2 months)",
       "notes": "Renew reminder before expiry."
      },
      {
       "name": "screening",
       "label": "Verification / screening status",
       "rule": "system",
       "type": "object",
       "control": "-",
       "options": [
        "Pending",
        "Live",
        "Rejected",
        "Verified"
       ],
       "strict": false,
       "notes": "Moderation queue before going live."
      }
     ]
    }
   ],
   "groups": {
    "unit_types": {
     "title": "Unit types",
     "min": 1,
     "max": 20,
     "fields": [
      {
       "name": "unit_kind",
       "label": "Unit type",
       "rule": "required",
       "type": "enum",
       "control": "Chips (single)",
       "options": [
        "Office",
        "Shop",
        "Showroom",
        "Food court unit",
        "Co-working seat",
        "Commercial plot"
       ],
       "strict": true,
       "group": "unit_types"
      },
      {
       "name": "area_kind",
       "label": "Area shown as",
       "rule": "required",
       "type": "enum",
       "control": "Radio",
       "options": [
        "Super built-up area",
        "Carpet area",
        "Plot area"
       ],
       "strict": true,
       "group": "unit_types"
      },
      {
       "name": "area_min",
       "label": "Area from (sq.ft)",
       "rule": "required",
       "type": "int",
       "control": "Number box",
       "group": "unit_types"
      },
      {
       "name": "area_max",
       "label": "Area up to (sq.ft)",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "notes": "Leave empty when every unit of this type has the same area.",
       "group": "unit_types"
      },
      {
       "name": "price_min",
       "label": "Price from",
       "rule": "required",
       "type": "money",
       "control": "Number box",
       "group": "unit_types"
      },
      {
       "name": "price_max",
       "label": "Price up to",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "group": "unit_types"
      },
      {
       "name": "price_note",
       "label": "Price note",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. + GST and registration",
       "group": "unit_types"
      },
      {
       "name": "units",
       "label": "Units of this type",
       "rule": "optional",
       "type": "int",
       "control": "Number box",
       "group": "unit_types"
      }
     ]
    },
    "floor_plans": {
     "title": "Floor plans",
     "min": 0,
     "max": 30,
     "fields": [
      {
       "name": "name",
       "label": "Plan name",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. 3 BHK, Ground floor, Type A",
       "group": "floor_plans"
      },
      {
       "name": "for_unit",
       "label": "For unit type",
       "rule": "optional",
       "type": "enum",
       "control": "Dropdown",
       "notes": "Groups the plans by unit type on the project page.",
       "options": [
        "Office",
        "Shop",
        "Showroom",
        "Food court unit",
        "Co-working seat",
        "Commercial plot",
        "Other"
       ],
       "strict": true,
       "group": "floor_plans"
      },
      {
       "name": "area_sqft",
       "label": "Area (sq.ft)",
       "rule": "optional",
       "type": "decimal",
       "control": "Number box",
       "group": "floor_plans"
      },
      {
       "name": "price",
       "label": "Price of this plan",
       "rule": "optional",
       "type": "money",
       "control": "Number box",
       "notes": "When units of this plan have their own price.",
       "group": "floor_plans"
      },
      {
       "name": "plan_2d",
       "label": "2D plan",
       "rule": "required",
       "type": "media",
       "control": "Upload",
       "hint": "One image (JPG, PNG or WebP)",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "plan_3d",
       "label": "3D plan",
       "rule": "optional",
       "type": "media",
       "control": "Upload",
       "hint": "One image, if you have a 3D view",
       "accept": "image",
       "max": 1,
       "group": "floor_plans"
      },
      {
       "name": "rooms",
       "label": "Room sizes",
       "rule": "optional",
       "type": "object",
       "control": "Room sizes table",
       "notes": "{unit: ft | m, rooms: [{name, length, width}]}",
       "group": "floor_plans"
      }
     ]
    },
    "nearby": {
     "title": "Nearby places",
     "min": 0,
     "max": 15,
     "fields": [
      {
       "name": "place",
       "label": "Place",
       "rule": "required",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. Airport, Metro station, School",
       "group": "nearby"
      },
      {
       "name": "distance_km",
       "label": "Distance (km)",
       "rule": "required",
       "type": "decimal",
       "control": "Number box",
       "group": "nearby"
      }
     ]
    },
    "progress": {
     "title": "Construction updates",
     "min": 0,
     "max": 36,
     "fields": [
      {
       "name": "month",
       "label": "Month",
       "rule": "required",
       "type": "month",
       "control": "Month-year picker",
       "group": "progress"
      },
      {
       "name": "photos",
       "label": "Site photos",
       "rule": "required",
       "type": "media",
       "control": "Multi-upload",
       "hint": "Up to 12 photos of the site this month",
       "accept": "image",
       "max": 12,
       "group": "progress"
      },
      {
       "name": "note",
       "label": "What was done",
       "rule": "optional",
       "type": "text",
       "control": "Text box",
       "hint": "e.g. Tower A slab up to the 10th floor; max 200 chars",
       "group": "progress"
      }
     ]
    }
   },
   "project": true
  }
 }
}
